export const HOME_PAGE_DATA = {
  heading: 'React Js Project Base Setup'
}

export const LATEST_NEWS = [
  {
    id: 1,
    title: "New Game Update Released",
    excerpt: "The latest patch brings new features and bug fixes to your favorite game.",
    date: "2023-05-15",
    image: "https://via.placeholder.com/300x200?text=News+1"
  },
  {
    id: 2,
    title: "Upcoming Game Announcement",
    excerpt: "The developers have revealed the release date for their highly anticipated title.",
    date: "2023-05-10",
    image: "https://via.placeholder.com/300x200?text=News+2"
  },
  {
    id: 3,
    title: "Esports Tournament Results",
    excerpt: "See which team took home the championship in the latest tournament.",
    date: "2023-05-05",
    image: "https://via.placeholder.com/300x200?text=News+3"
  }
];

export const IMAGE_EXTENSIONS = [
  'png', 'jpg', 'webp', 'svg'
]

export const GAME_SUMMARY = [
  {
    "title": "The Witcher 3: Wild Hunt",
    "slug": "the-witcher-3-wild-hunt",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/292030/header.jpg",
    "description": "The Witcher 3: Wild Hunt is a critically acclaimed open-world action RPG developed by CD Projekt Red. Set in a beautifully crafted, vast fantasy world, the game follows Geralt of Rivia, a skilled monster hunter, on a perilous journey to find his adopted daughter, Ciri, who is being pursued by a mysterious and deadly force known as the Wild Hunt...",
    "category": [
      "PC Games",
      "Top Games"
    ]
  },
  {
    "title": "Elden Ring",
    "slug": "elden-ring",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1245620/header.jpg",
    "description": "Elden Ring is an open-world action RPG from the creators of the Souls series, including the renowned FromSoftware and famed author George R.R. Martin. Set in the beautiful and bleak world of the Lands Between, players assume the role of a Tarnished, an exiled warrior on a quest to restore the Elden Ring and become the Elden Lord...",
    "category": [
      "PC Games",
      "Top Games"
    ]
  },
  {
    "title": "Red Dead Redemption 2",
    "slug": "red-dead-redemption-2",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1174180/header.jpg",
    "description": "Red Dead Redemption 2 is an action-adventure game developed by Rockstar Games. Set in the dying days of the Wild West, players take on the role of Arthur Morgan, a member of the Van der Linde gang, as they navigate a sprawling, immersive open world filled with dynamic events, complex characters, and a gripping narrative...",
    "category": [
      "PC Games",
      "Top Games"
    ]
  },
  {
    "title": "Cyberpunk 2077",
    "slug": "cyberpunk-2077",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1091500/header.jpg",
    "description": "Cyberpunk 2077 is an open-world RPG set in the dystopian Night City. Players assume the role of V, a mercenary who embarks on a journey filled with hacking, combat, and uncovering hidden truths in a futuristic world...",
    "category": [
      "PC Games",
      "Top Games"
    ]
  },
  {
    "title": "DOOM Eternal",
    "slug": "doom-eternal",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/782330/header.jpg",
    "description": "DOOM Eternal is a fast-paced first-person shooter developed by id Software and published by Bethesda Softworks. Players take on the role of the Doom Slayer, tasked with saving Earth from the demonic invasion...",
    "category": [
      "PC Games",
      "Top Games"
    ]
  },
  {
    "title": "Minecraft",
    "slug": "minecraft",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/573170/header.jpg",
    "description": "Minecraft is a sandbox game allowing players to explore, build, and survive in a blocky, procedurally generated world...",
    "category": [
      "PC Games",
      "Top Games"
    ]
  },
  {
    "title": "Valorant",
    "slug": "valorant",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1431050/header.jpg",
    "description": "Valorant is a free-to-play tactical first-person shooter developed by Riot Games. The game features team-based, objective-oriented gameplay where players select from a roster of unique characters, each with their own abilities. Players compete in 5v5 matches where one team attempts to plant a bomb while the other team defends...",
    "category": [
      "PC Games",
      "Top Games"
    ]
  },
  {
    "title": "Stardew Valley",
    "slug": "stardew-valley",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/header.jpg",
    "description": "Stardew Valley is a farming simulation RPG where players inherit a run-down farm and work to restore it to its former glory. The game offers various activities like planting crops, fishing, raising animals, and exploring caves. As players build relationships with the townspeople, they can also take on quests, attend events, and participate in festivals...",
    "category": [
      "PC Games",
      "Top Games"
    ]
  },
  {
    "title": "Civilization VI",
    "slug": "civilization-vi",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/289070/header.jpg",
    "description": "Civilization VI is a turn-based strategy game where players lead a civilization from the Stone Age to the Information Age. Players manage resources, conduct diplomacy, build cities, and engage in military conflicts to achieve one of several victory conditions...",
    "category": [
      "PC Games",
      "Top Games"
    ]
  },
  {
    "title": "Age of Empires IV",
    "slug": "age-of-empires-iv",
    "subtitle": "A Grand Strategy Game",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1466860/header.jpg",
    "description": "Age of Empires IV is a real-time strategy game where players command historical civilizations, build empires, and engage in epic battles.",
    "category": [
      "PC Games",
      "Strategy Games"
    ]
  },
  {
    "title": "Animal Crossing: New Horizons",
    "slug": "animal-crossing-new-horizons",
    "subtitle": "A Relaxing Life Simulation",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1693850/header.jpg",
    "description": "Animal Crossing: New Horizons invites players to create their idyllic island life, interacting with villagers, crafting, and designing.",
    "category": [
      "Nintendo Switch",
      "Simulation Games"
    ]
  },
  {
    "title": "Assassin's Creed Odyssey",
    "slug": "assassins-creed-odyssey",
    "subtitle": "An Epic Open-World Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/812140/header.jpg",
    "description": "Set in Ancient Greece, Assassin's Creed Odyssey allows players to embark on a journey as a mercenary exploring a vast open world filled with choices and mysteries.",
    "category": [
      "PC Games",
      "PS4",
      "PS5",
      "Action Adventure"
    ]
  },
  {
    "title": "Bloodborne",
    "slug": "bloodborne",
    "subtitle": "A Dark and Gothic RPG",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/349280/header.jpg",
    "description": "Bloodborne challenges players to survive in a gothic city filled with eldritch horrors, blending brutal combat with deep lore.",
    "category": [
      "PS4",
      "Action RPG"
    ]
  },
  {
    "title": "Civilization V",
    "slug": "civilization-v",
    "subtitle": "Turn-Based Strategy Masterpiece",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/8930/header.jpg",
    "description": "Civilization V lets players lead a civilization from ancient times to the modern era, focusing on diplomacy, war, and cultural growth.",
    "category": [
      "PC Games",
      "Strategy Games"
    ]
  },
  {
    "title": "Counter-Strike: Global Offensive",
    "slug": "counter-strike-global-offensive",
    "subtitle": "A Competitive FPS Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/730/header.jpg",
    "description": "Counter-Strike: Global Offensive (CS: GO) is the latest installment in the Counter-Strike series, which revolutionized the tactical first-person shooter genre. CS: GO is all about team-based, objective-driven gameplay, where two teams – Terrorists and Counter-Terrorists – battle it out in various missions such as planting or defusing bombs, or rescuing hostages. It features a wide range of weapons, maps, and game modes. The game is known for its competitive nature, with a thriving esports scene and an in-depth ranking system that determines player skill. The gameplay focuses heavily on strategy, communication, and quick reflexes, making it a favorite among professional and casual gamers alike.",
    "category": [
      "PC Games",
      "Competitive Games"
    ]
  },
  {
    "title": "Dark Souls III",
    "slug": "dark-souls-iii",
    "subtitle": "A Challenging RPG Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/374320/header.jpg",
    "description": "Dark Souls III, developed by FromSoftware, is a punishing action RPG that follows in the footsteps of its predecessors with its signature brutal combat and deep lore. Players control a character known as the Ashen One, embarking on a journey through the decaying world of Lothric. The game is renowned for its difficulty, demanding that players master a complex combat system that requires perfect timing and strategy. The intricate world is interconnected, with hidden secrets and lore-rich environments. Boss battles are among the toughest in the genre, each requiring precise tactics and perfect execution. Dark Souls III also introduces a new world-building mechanic and more open exploration than its predecessors, alongside enhanced visuals and a refined combat system.",
    "category": [
      "PC Games",
      "PS4",
      "Action RPG"
    ]
  },
  {
    "title": "Deus Ex: Mankind Divided",
    "slug": "deus-ex-mankind-divided",
    "subtitle": "A Cyberpunk Action Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/337000/header.jpg",
    "description": "Deus Ex: Mankind Divided is a cyberpunk-themed action RPG set in a world where people with augmented abilities are segregated from the general populace. Players take on the role of Adam Jensen, a security specialist with mechanical augmentations, as he fights to expose a vast conspiracy that threatens global security. The game combines stealth, action, and RPG elements, giving players multiple ways to approach objectives – whether through hacking, combat, or persuasion. Its world-building is deep and immersive, with branching storylines that react to player choices. The game features intricate combat mechanics, augmented abilities, and a narrative driven by moral dilemmas.",
    "category": [
      "PC Games",
      "PS4"
    ]
  },
  {
    "title": "Divinity: Original Sin 2",
    "slug": "divinity-original-sin-2",
    "subtitle": "A Critically Acclaimed RPG",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/435150/header.jpg",
    "description": "Divinity: Original Sin 2 is a modern RPG masterpiece, praised for its deep role-playing elements, turn-based combat system, and exceptional story. Set in a rich fantasy world on the brink of war, players control a party of unique characters, each with their own backstory, abilities, and moral compass. The game features a dynamic narrative where player choices can drastically affect the world and story, from politics to relationships and combat outcomes. With a fully realized open world, stunning graphics, and intricate dialogue choices, the game offers immense replayability. The cooperative multiplayer mode allows players to form teams and tackle quests together, making every playthrough a unique experience.",
    "category": [
      "PC Games",
      "PS4",
      "Co-op RPG"
    ]
  },
  {
    "title": "Dragon Age: Inquisition",
    "slug": "dragon-age-inquisition",
    "subtitle": "An Immersive Fantasy RPG",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1222690/header.jpg",
    "description": "Dragon Age: Inquisition is a sprawling RPG set in the world of Thedas, where players control the Inquisitor, a leader tasked with closing the breach between the world and the chaos of the Fade. Players must navigate political intrigue, battle dangerous enemies, and explore a vast open world filled with danger and mystery. The game offers a highly customizable experience with choices that directly impact the story, from dialogue options to combat strategies. The game also features tactical combat, where players can pause the action to issue commands, as well as real-time action for those who prefer a more hands-on approach.",
    "category": [
      "PC Games",
      "PS4",
      "PS5"
    ]
  },
  {
    "title": "DOOM (2016)",
    "slug": "doom-2016",
    "subtitle": "Fast-Paced FPS Action",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/379720/header.jpg",
    "description": "DOOM (2016) is a reboot of the iconic DOOM series, focusing on fast-paced, brutal combat with a heavy emphasis on movement and destruction. Players take control of the Doom Slayer, a legendary warrior tasked with saving Earth from demonic invasion. The game is known for its fluid combat system, where players chain together gunplay, chainsaw attacks, and power-ups to obliterate waves of enemies. DOOM (2016) also introduces the “Glory Kill” mechanic, allowing players to perform brutal finishing moves on weakened enemies. The game’s level design is fast, linear, and filled with hidden secrets and upgrades.",
    "category": [
      "PC Games",
      "PS4",
      "FPS Games"
    ]
  },
  {
    "title": "Far Cry 5",
    "slug": "far-cry-5",
    "subtitle": "A Gripping Open-World Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/552520/header.jpg",
    "description": "Far Cry 5 is an open-world first-person shooter set in a rural Montana county overrun by a religious cult. Players assume the role of a sheriff’s deputy who is tasked with bringing down the cult and saving the locals. The game features a huge open world with diverse environments, wildlife, and vehicles. Players can approach missions in any way they choose, from stealth and strategy to full-on combat. The story is driven by a cast of memorable characters and offers a rich narrative filled with conspiracy, intrigue, and explosive action.",
    "category": [
      "PC Games",
      "PS4",
      "PS5"
    ]
  },
  {
    "title": "Farm Together",
    "slug": "farm-together",
    "subtitle": "A Cooperative Farming Simulator",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/699190/header.jpg",
    "description": "Farm Together is a farming simulator where players build and maintain their farms, plant crops, and raise animals. The game features cooperative multiplayer, where players can join each other’s farms, help with tasks, and earn rewards together. Players can design their farms however they like, planting crops, building structures, and even participating in various mini-games. The game is designed to be relaxing and stress-free, with no penalties for taking breaks. It offers a seamless multiplayer experience and a variety of customization options to make each farm unique.",
    "category": [
      "PC Games",
      "PS4",
      "Co-op Games"
    ]
  },
  {
    "title": "Grand Theft Auto V",
    "slug": "grand-theft-auto-v",
    "subtitle": "A Modern Open-World Masterpiece",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/271590/header.jpg",
    "description": "Grand Theft Auto V is an open-world action-adventure game set in the fictional city of Los Santos. Players take on the roles of three protagonists – Michael, Trevor, and Franklin – and carry out a series of high-stakes heists. The game is known for its rich narrative, sprawling open world, and varied gameplay. Players can engage in a variety of activities, from heists and firefights to sports and entertainment. The game also features an online multiplayer mode, where players can create and participate in missions, races, and other events.",
    "category": [
      "PC Games",
      "PS4",
      "PS5",
      "Open-World Games"
    ]
  },
  {
    "title": "Halo: The Master Chief Collection",
    "slug": "halo-master-chief-collection",
    "subtitle": "A Legendary FPS Collection",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/976730/header.jpg",
    "description": "Halo: The Master Chief Collection is a compilation of all the main Halo games, including remastered versions and additional content. Players can experience the story of Master Chief, a super-soldier in a futuristic world, fighting against alien forces known as the Covenant. The collection includes campaigns from various Halo titles, including Halo: Combat Evolved, Halo 2, Halo 3, and Halo 4, along with multiplayer modes. The game also features remastered visuals, improved mechanics, and a larger online community. It’s the ultimate package for Halo fans, offering both nostalgic content and a modern experience.",
    "category": [
      "PC Games",
      "FPS Games"
    ]
  },
  {
    "title": "Watch Dogs: Legion",
    "slug": "watch-dogs-legion",
    "subtitle": "A Revolutionary Open-World Action Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/978800/header.jpg",
    "description": "Watch Dogs: Legion is an open-world action game that takes place in a near-future London, controlled by an oppressive regime. The game introduces the ability to recruit and play as virtually any NPC in the world. Players control a resistance group aiming to free London from authoritarian control, and every NPC in the game has a unique backstory, skills, and attributes. The game’s story is driven by the player’s actions and decisions, allowing for immense flexibility in how the world is navigated. From stealthy infiltration to open combat, players can approach missions in their own way, adding great replay value and personalization.",
    "category": [
      "PC Games",
      "PS4",
      "PS5",
      "Open-World Games"
    ]
  },
  {
    "title": "Wolfenstein: Youngblood",
    "slug": "wolfenstein-youngblood",
    "subtitle": "Co-Op First-Person Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1045770/header.jpg",
    "description": "Wolfenstein: Youngblood is a first-person shooter set in an alternate history where Nazi forces have taken over the world. The game follows BJ Blazkowicz’s twin daughters, Jess and Soph, as they embark on a mission to find their father and fight Nazi forces in a 1980s Paris. This entry in the Wolfenstein series introduces cooperative multiplayer, allowing players to team up with a friend for the first time in the series. The game blends classic FPS gameplay with RPG elements, offering various upgrades, weapons, and abilities to defeat Nazi forces.",
    "category": [
      "PC Games",
      "PS4",
      "Co-op Games"
    ]
  },
  {
    "title": "Terraria",
    "slug": "terraria",
    "subtitle": "A 2D Sandbox Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/105600/header.jpg",
    "description": "Terraria is a 2D sandbox game that mixes exploration, building, and combat. Players can dig, build, fight, and explore a procedurally generated world full of treasures and enemies. The game features various biomes, from forests to deserts to underground caverns. Players can craft items, gather resources, and defeat bosses. Terraria also includes multiplayer, allowing friends to team up for adventures or create shared worlds. The game’s simple mechanics are enhanced by the creative freedom it offers, allowing players to build complex structures or engage in thrilling battles.",
    "category": [
      "PC Games",
      "PS4",
      "Sandbox Games"
    ]
  },
  {
    "title": "Watch Dogs 2",
    "slug": "watch-dogs-2",
    "subtitle": "Hack the World, Save the Future",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/447040/header.jpg",
    "description": "Watch Dogs 2 is an open-world action-adventure game where players take control of Marcus Holloway, a young hacker trying to expose a corrupt corporation while uncovering a massive conspiracy. Set in the tech-savvy city of San Francisco, the game allows players to hack into various devices, control vehicles, and manipulate the environment to complete missions. The game combines stealth, combat, and puzzles with an engaging story that tackles issues such as privacy, surveillance, and social inequality.",
    "category": [
      "PC Games",
      "PS4",
      "PS5",
      "Action Adventure"
    ]
  },
  {
    "title": "Subnautica",
    "slug": "subnautica",
    "subtitle": "A Deep Sea Exploration Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/264710/header.jpg",
    "description": "Subnautica is an open-world survival game set on an alien ocean planet. Players control a character who survives a crash landing on the planet and must gather resources, craft equipment, and explore the ocean depths. The game features a rich environment filled with various biomes, from coral reefs to dark, dangerous underwater caves. Players must manage hunger, thirst, and oxygen while exploring the world and uncovering the mysteries of the planet. The game combines elements of exploration, crafting, and storytelling in a unique and immersive way.",
    "category": [
      "PC Games",
      "PS4",
      "Survival Games"
    ]
  },
  {
    "title": "My Time at Portia",
    "slug": "my-time-at-portia",
    "subtitle": "A Charming Life-Simulation RPG",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/666140/header.jpg",
    "description": "My Time at Portia is a delightful life-simulation RPG set in a post-apocalyptic world where humanity is rebuilding civilization. Players take on the role of a workshop owner in the vibrant town of Portia, tasked with restoring the workshop, crafting various items, and helping the town thrive. The game features an open-world experience with farming, fishing, mining, dungeon exploration, and relationship-building mechanics. With its heartwarming story, colorful visuals, and engaging gameplay, My Time at Portia offers a relaxing yet immersive experience for players who enjoy crafting, exploration, and social interactions.",
    "category": [
      "PC Games",
      "PS4",
      "Nintendo Switch",
      "Life Simulation"
    ]
  },
  {
    "title": "Overwatch",
    "slug": "overwatch",
    "subtitle": "A Team-Based Multiplayer Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/411010/header.jpg",
    "description": "Overwatch is a fast-paced, team-based first-person shooter developed by Blizzard Entertainment. Players choose from a diverse roster of heroes, each with unique abilities and roles, to compete in objective-based matches. The game emphasizes teamwork and strategy, with roles such as tank, damage, and support characters working together to achieve victory. Overwatch features a variety of game modes, including Quick Play, Competitive Play, and Arcade, as well as seasonal events with exclusive skins and challenges. With dynamic maps, engaging character interactions, and a constantly evolving meta, Overwatch remains one of the most beloved multiplayer shooters in gaming.",
    "category": [
      "PC Games",
      "PS4",
      "PS5",
      "FPS",
      "Multiplayer"
    ]
  },
  {
    "title": "Paladins",
    "slug": "paladins",
    "subtitle": "A Free-to-Play Hero Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/header.jpg",
    "description": "Paladins is a free-to-play team-based shooter that combines fast-paced action with strategic depth. Players select from a wide range of champions, each with their own unique abilities and playstyles. The game features a deck-building system that allows players to customize their abilities, adding an extra layer of strategy. With multiple game modes, including Siege, Onslaught, and Team Deathmatch, Paladins offers an engaging competitive experience. Its vibrant fantasy setting and accessible gameplay make it a great alternative to Overwatch and other hero-based shooters.",
    "category": [
      "PC Games",
      "PS4",
      "Nintendo Switch",
      "FPS",
      "Multiplayer"
    ]
  },
  {
    "title": "Sekiro: Shadows Die Twice",
    "slug": "sekiro-shadows-die-twice",
    "subtitle": "A Hardcore Samurai Action-Adventure Game",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/814380/header.jpg",
    "description": "Sekiro: Shadows Die Twice is an action-adventure game set in Sengoku-era Japan, where players take control of a shinobi known as Wolf. Tasked with rescuing his kidnapped lord, Wolf must navigate treacherous environments, battle deadly foes, and master a unique combat system based on precision, deflection, and counters. Unlike FromSoftware’s Souls games, Sekiro focuses on fast, skill-based combat with a strong emphasis on swordplay and stealth. The game features stunning visuals, immersive world-building, and brutal difficulty, rewarding patience and mastery. With multiple endings, Sekiro offers high replay value for players who seek a challenging experience.",
    "category": [
      "PC Games",
      "PS4",
      "Action Adventure"
    ]
  },
  {
    "title": "Age of Empires II: Definitive Edition",
    "slug": "age-of-empires-ii-definitive-edition",
    "subtitle": "The Classic RTS Reborn",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/813780/header.jpg",
    "description": "Age of Empires II: Definitive Edition is the remastered version of the classic real-time strategy game, offering enhanced graphics, all the previous expansions, and new content. Players can build civilizations, manage resources, and engage in tactical warfare across multiple historical campaigns. With an expanded multiplayer mode, AI improvements, and new civilizations, this edition breathes new life into the legendary RTS that has stood the test of time.",
    "category": [
      "PC Games",
      "Strategy",
      "RTS"
    ]
  },
  {
    "title": "The Sims 4",
    "slug": "the-sims-4",
    "subtitle": "Create and Control Your World",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1222670/header.jpg",
    "description": "The Sims 4 is a life simulation game that allows players to create and control virtual people, build homes, and shape their lives. With various expansion packs and customization options, players can create unique Sims, furnish homes, pursue careers, and develop relationships. The game offers a rich variety of activities, from career advancement to hobby exploration, all while navigating the ups and downs of life. The Sims 4 continues to expand with new features and content through regular updates and expansions.",
    "category": [
      "PC Games",
      "Simulation",
      "Life Simulation"
    ]
  },
  {
    "title": "Assassin's Creed Valhalla",
    "slug": "assassins-creed-valhalla",
    "subtitle": "An Epic Viking Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/976730/header.jpg",
    "description": "Assassin’s Creed Valhalla takes players into the Viking age, where they play as Eivor, a Viking warrior on a quest to build a new home in England. The game features open-world exploration, brutal combat, and complex storylines with decisions that shape the world. Players can raid settlements, explore England and Norway, and engage in deep RPG mechanics such as leveling up, gear customization, and building alliances. Valhalla continues the series’ tradition of blending history with fiction and introduces new features like settlement-building and naval exploration.",
    "category": [
      "PC Games",
      "PS4",
      "PS5",
      "Action RPG"
    ]
  },
  {
    "title": "Total War: Rome II",
    "slug": "total-war-rome-ii",
    "subtitle": "The Epic Strategy of Ancient Rome",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/214950/header.jpg",
    "description": "Total War: Rome II is a grand strategy game set in the ancient Roman era. Players take control of a Roman faction and must manage resources, armies, and diplomacy to conquer the known world. The game features large-scale tactical battles, political maneuvering, and the strategic management of armies and settlements. The game’s expansive campaign map spans across the Mediterranean world, and players must make key decisions about alliances, wars, and governance to expand their empire. With various factions to choose from and deep historical accuracy, Rome II offers a comprehensive strategy experience.",
    "category": [
      "PC Games",
      "Strategy",
      "RTS"
    ]
  },
  {
    "title": "Tom Clancy's Rainbow Six Siege",
    "slug": "rainbow-six-siege",
    "subtitle": "Tactical Multiplayer Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/359550/header.jpg",
    "description": "Tom Clancy's Rainbow Six Siege is a tactical first-person shooter that emphasizes strategic gameplay, teamwork, and environmental destruction. Players take control of elite operators from various counter-terrorism units around the world. The game offers a variety of modes, including Bomb, Hostage, and Secure Area, with players engaging in intense, close-quarters combat. Siege’s destructible environments allow for dynamic combat, where every wall, floor, and ceiling is a potential access point for attackers and defenders. The game has a thriving esports scene and frequent updates with new operators, maps, and features.",
    "category": [
      "PC Games",
      "PS4",
      "Xbox One",
      "FPS",
      "Multiplayer"
    ]
  },
  {
    "title": "Assassin's Creed Syndicate",
    "slug": "assassins-creed-syndicate",
    "subtitle": "London, 1868 - A War Between Assassins and Templars",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/361310/header.jpg",
    "description": "Assassin’s Creed Syndicate takes place in Victorian London, during a time of industrial revolution and societal upheaval. Players take control of two playable characters: Jacob Frye and his twin sister Evie. Together, they fight to free London from the oppressive rule of the Templar Order while navigating the city’s underworld. The game offers an open-world environment with a variety of activities, including combat, stealth, and exploration. Players can use a range of weapons and gadgets, as well as recruit gang members to take over different territories across the city.",
    "category": [
      "PC Games",
      "PS4",
      "Xbox One",
      "Action Adventure"
    ]
  },
  {
    "title": "Pillars of Eternity II: Deadfire",
    "slug": "pillars-of-eternity-ii-deadfire",
    "subtitle": "An Epic RPG Adventure in the Vast Ocean",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/560130/header.jpg",
    "description": "Pillars of Eternity II: Deadfire is a sequel to the critically acclaimed RPG set in the world of Eora. Players take control of the Watcher, a character who has the ability to see and communicate with souls. The game features an open-world exploration of the Deadfire Archipelago, a region filled with various islands to explore, and diverse factions vying for power. Players can engage in tactical combat, recruit companions, and make critical decisions that affect the outcome of the story. The game offers an immersive experience with deep lore, intricate dialogues, and multiple endings.",
    "category": [
      "PC Games",
      "RPG"
    ]
  },
  {
    "title": "Baldur's Gate III",
    "slug": "baldurs-gate-iii",
    "subtitle": "A New RPG in the Legendary Franchise",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1086940/header.jpg",
    "description": "Baldur’s Gate III is the long-awaited return to the iconic RPG series set in the Dungeons & Dragons universe. The game offers deep narrative choices, turn-based combat, and expansive character customization. Players control a group of adventurers who must navigate the complex and dangerous world of Faerûn while dealing with the influence of a powerful and sinister force. The game features an engaging single-player story, as well as multiplayer modes where players can team up to explore the world together. The game emphasizes player choice, with consequences that ripple through the story.",
    "category": [
      "PC Games",
      "RPG",
      "Turn-Based Combat"
    ]
  },
  {
    "title": "The Elder Scrolls V: Skyrim Special Edition",
    "slug": "skyrim-special-edition",
    "subtitle": "The Legendary RPG Reborn in High Definition",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/489830/header.jpg",
    "description": "The Elder Scrolls V: Skyrim Special Edition is a remastered version of the legendary open-world RPG, Skyrim. With improved graphics, enhanced features, and all the DLC expansions, the Special Edition offers the ultimate Skyrim experience. Players can explore the vast open world of Skyrim, interact with NPCs, join factions, and engage in combat and magic. As the Dragonborn, players must stop the ancient dragon Alduin from destroying the world. Skyrim is known for its rich story, deep world-building, and freedom of choice, making it one of the most beloved RPGs of all time.",
    "category": [
      "PC Games",
      "PS4",
      "Xbox One",
      "RPG"
    ]
  },
  {
    "title": "Mass Effect Legendary Edition",
    "slug": "mass-effect-legendary-edition",
    "subtitle": "The Ultimate RPG Trilogy Remastered",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1328670/header.jpg",
    "description": "Mass Effect Legendary Edition is a remastered version of the iconic Mass Effect trilogy, offering improved visuals, enhanced gameplay, and all the downloadable content (DLC) released for the original games. The game follows Commander Shepard as they attempt to stop a galactic threat by uniting various alien races. The game offers deep storylines, character customization, and tactical combat. With updated graphics and smoother gameplay mechanics, Mass Effect Legendary Edition brings the epic sci-fi RPG to modern players.",
    "category": [
      "PC Games",
      "PS4",
      "Xbox One",
      "RPG"
    ]
  },
  {
    "title": "Destiny 2",
    "slug": "destiny-2",
    "subtitle": "The Ultimate FPS MMO Experience",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1085660/header.jpg",
    "description": "Destiny 2 is an online multiplayer first-person shooter set in a shared open-world environment. Players take on the role of Guardians, protectors of the last city on Earth, as they fight against various alien enemies, explore different planets, and take part in cooperative and competitive activities. The game features a dynamic progression system, allowing players to level up, obtain new weapons and gear, and join clans for additional multiplayer content. With frequent updates, expansions, and seasonal content, Destiny 2 offers a constantly evolving universe.",
    "category": [
      "PC Games",
      "FPS",
      "MMO"
    ]
  },
  {
    "title": "Metro Exodus",
    "slug": "metro-exodus",
    "subtitle": "A Post-Apocalyptic Survival Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/412020/header.jpg",
    "description": "Metro Exodus is a first-person shooter set in a post-apocalyptic Russia, where players assume the role of Artyom, a soldier fighting to survive against the remnants of humanity and mutated creatures. The game is a hybrid of open-world exploration and linear storytelling, featuring intense combat, stealth, and survival mechanics. The game’s storyline follows Artyom as he journeys across the Russian landscape, hoping to find a new home while unraveling dark secrets about the state of the world. Metro Exodus offers breathtaking visuals, a haunting atmosphere, and deep narrative elements.",
    "category": [
      "PC Games",
      "PS4",
      "Xbox One",
      "Shooter"
    ]
  },
  {
    "title": "Call of Duty: Warzone",
    "slug": "call-of-duty-warzone",
    "subtitle": "A Battle Royale Experience",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1642490/header.jpg",
    "description": "Call of Duty: Warzone is a free-to-play battle royale game that features intense combat, tactical gameplay, and a wide variety of weapons. Players drop into a massive open map, scavenge for weapons and gear, and compete to be the last team or player standing. The game features multiple game modes, including solos, duos, and squads, with a variety of unique mechanics like the Gulag, where eliminated players can fight for a chance to re-enter the game. Warzone features cross-platform play, seasonal updates, and new content regularly.",
    "category": [
      "PC Games",
      "PS4",
      "Xbox One",
      "Battle Royale"
    ]
  },
  {
    "title": "Starbound",
    "slug": "starbound",
    "subtitle": "Explore, Build, and Survive in Space",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/211820/header.jpg",
    "description": "Starbound is a procedurally generated sandbox game set in space, where players take on the role of a space explorer. The game offers exploration, crafting, and combat across an endless universe filled with planets, alien creatures, and hidden treasures. Players can build structures, fight enemies, and engage in various quests while discovering new planets and improving their space-faring capabilities. With a strong emphasis on creativity, Starbound offers countless possibilities for exploration and adventure in the stars.",
    "category": [
      "PC Games",
      "Indie",
      "Action Adventure"
    ]
  }
]


export const GAME_DETAILS = {
  "the-witcher-3-wild-hunt": {
    "title": "The Witcher 3: Wild Hunt",
    "developer": "CD Projekt Red",
    "publisher": "CD Projekt",
    "releaseDate": "May 19, 2015",
    "description": "The Witcher 3: Wild Hunt is a critically acclaimed open-world action RPG developed by CD Projekt Red. Set in a beautifully crafted, vast fantasy world, the game follows Geralt of Rivia, a skilled monster hunter, on a perilous journey to find his adopted daughter, Ciri, who is being pursued by a mysterious and deadly force known as the Wild Hunt...",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/292030/header.jpg",
    "category": [
      "PC Games",
      "Top Games"
    ],
    "images": [
      "https://cdn.cloudflare.steamstatic.com/steam/apps/292030/ss_1.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/292030/ss_2.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/292030/ss_3.jpg"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: 64-bit Windows 7, 8, or 10",
        "Processor: Intel Core i5-2500K or AMD Phenom II X4 940",
        "Memory: 6 GB RAM",
        "Graphics: Nvidia GeForce GTX 660 or AMD Radeon HD 7870",
        "Storage: 35 GB available space"
      ],
      "recommended": [
        "OS: 64-bit Windows 7, 8, or 10",
        "Processor: Intel Core i7 3770 or AMD FX-8350",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 770 or AMD Radeon R9 290",
        "Storage: 35 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=c0i88t0Kacs"
    },
    "relatedGames": [
      {
        "title": "Cyberpunk 2077",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1091500/header.jpg",
        "slug": "cyberpunk-2077"
      },
      {
        "title": "Dragon Age: Inquisition",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1222690/header.jpg",
        "slug": "dragon-age-inquisition"
      },
      {
        "title": "Divinity: Original Sin 2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/435150/header.jpg",
        "slug": "divinity-original-sin-2"
      }
    ]
  },
  "elden-ring": {
    "title": "Elden Ring",
    "developer": "FromSoftware",
    "publisher": "Bandai Namco Entertainment",
    "releaseDate": "February 25, 2022",
    "description": "Elden Ring is an open-world action RPG from the creators of the Souls series, including the renowned FromSoftware and famed author George R.R. Martin. Set in the beautiful and bleak world of the Lands Between, players assume the role of a Tarnished, an exiled warrior on a quest to restore the Elden Ring and become the Elden Lord...",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1245620/header.jpg",
    "category": [
      "PC Games",
      "Top Games"
    ],
    "images": [
      "https://cdn.cloudflare.steamstatic.com/steam/apps/1245620/ss_1.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/1245620/ss_2.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/1245620/ss_3.jpg"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 10",
        "Processor: Intel Core i5-8400 or AMD Ryzen 3 3300X",
        "Memory: 12 GB RAM",
        "Graphics: Nvidia GeForce GTX 1060 3GB or AMD Radeon RX 580 4GB",
        "Storage: 60 GB available space"
      ],
      "recommended": [
        "OS: Windows 10",
        "Processor: Intel Core i7-8700K or AMD Ryzen 5 3600X",
        "Memory: 16 GB RAM",
        "Graphics: Nvidia GeForce GTX 1070 8GB or AMD Radeon RX Vega 56 8GB",
        "Storage: 60 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=E3Huy2cdih0"
    },
    "relatedGames": [
      {
        "title": "Dark Souls III",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/374320/header.jpg",
        "slug": "dark-souls-iii"
      },
      {
        "title": "Bloodborne",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/349280/header.jpg",
        "slug": "bloodborne"
      },
      {
        "title": "Sekiro: Shadows Die Twice",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/814380/header.jpg",
        "slug": "sekiro-shadows-die-twice"
      }
    ]
  },
  "red-dead-redemption-2": {
    "title": "Red Dead Redemption 2",
    "developer": "Rockstar Games",
    "publisher": "Rockstar Games",
    "releaseDate": "October 26, 2018",
    "description": "Red Dead Redemption 2 is an action-adventure game developed by Rockstar Games. Set in the dying days of the Wild West, players take on the role of Arthur Morgan, a member of the Van der Linde gang, as they navigate a sprawling, immersive open world filled with dynamic events, complex characters, and a gripping narrative...",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1174180/header.jpg",
    "category": [
      "PC Games",
      "Top Games"
    ],
    "images": [
      "https://cdn.cloudflare.steamstatic.com/steam/apps/1174180/ss_1.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/1174180/ss_2.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/1174180/ss_3.jpg"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 64-bit",
        "Processor: Intel Core i5-2500K or AMD FX-6300",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 770 2GB or AMD Radeon R9 280 3GB",
        "Storage: 150 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i7-4770K or AMD Ryzen 5 1500X",
        "Memory: 12 GB RAM",
        "Graphics: Nvidia GeForce GTX 1060 6GB or AMD Radeon RX 480 4GB",
        "Storage: 150 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=gmA6MrX81z4"
    },
    "relatedGames": [
      {
        "title": "Grand Theft Auto V",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/271590/header.jpg",
        "slug": "grand-theft-auto-v"
      },
      {
        "title": "Far Cry 5",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/552520/header.jpg",
        "slug": "far-cry-5"
      },
      {
        "title": "Assassin's Creed Odyssey",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/812140/header.jpg",
        "slug": "assassins-creed-odyssey"
      }
    ]
  },
  "cyberpunk-2077": {
    "title": "Cyberpunk 2077",
    "developer": "CD Projekt Red",
    "publisher": "CD Projekt",
    "releaseDate": "December 10, 2020",
    "description": "Cyberpunk 2077 is an open-world RPG set in the dystopian Night City. Players assume the role of V, a mercenary who embarks on a journey filled with hacking, combat, and uncovering hidden truths in a futuristic world...",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1091500/header.jpg",
    "category": [
      "PC Games",
      "Top Games"
    ],
    "images": [
      "https://cdn.cloudflare.steamstatic.com/steam/apps/1091500/ss_1.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/1091500/ss_2.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/1091500/ss_3.jpg"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 or 10 (64-bit)",
        "Processor: Intel Core i5-3570K or AMD Ryzen 3 2300X",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GTX 780 3GB or AMD Radeon RX 470 4GB",
        "Storage: 70 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i7-4790 or AMD Ryzen 3 3200G",
        "Memory: 12 GB RAM",
        "Graphics: Nvidia GTX 1060 6GB or AMD Radeon RX 590",
        "Storage: 70 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Watch Dogs: Legion",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/978800/header.jpg",
        "slug": "watch-dogs-legion"
      },
      {
        "title": "Deus Ex: Mankind Divided",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/337000/header.jpg",
        "slug": "deus-ex-mankind-divided"
      },
      {
        "title": "The Witcher 3: Wild Hunt",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/292030/header.jpg",
        "slug": "the-witcher-3-wild-hunt"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=8X2kIfS6fb8"
    }
  },
  "doom-eternal": {
    "title": "DOOM Eternal",
    "developer": "id Software",
    "publisher": "Bethesda Softworks",
    "releaseDate": "March 20, 2020",
    "description": "DOOM Eternal is a fast-paced first-person shooter developed by id Software and published by Bethesda Softworks. Players take on the role of the Doom Slayer, tasked with saving Earth from the demonic invasion...",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/782330/header.jpg",
    "category": [
      "PC Games",
      "Top Games"
    ],
    "images": [
      "https://cdn.cloudflare.steamstatic.com/steam/apps/782330/ss_1.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/782330/ss_2.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/782330/ss_3.jpg"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 64-bit",
        "Processor: Intel Core i5-2400 or AMD Ryzen 3 1200",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 1050 Ti or AMD Radeon RX 560",
        "Storage: 50 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i7-6700K or AMD Ryzen 7 2700X",
        "Memory: 16 GB RAM",
        "Graphics: Nvidia GeForce GTX 1080 or AMD Radeon RX Vega 56",
        "Storage: 50 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "DOOM (2016)",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/379720/header.jpg",
        "slug": "doom-2016"
      },
      {
        "title": "Wolfenstein: Youngblood",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1045770/header.jpg",
        "slug": "wolfenstein-youngblood"
      },
      {
        "title": "Halo: The Master Chief Collection",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/976730/header.jpg",
        "slug": "halo-master-chief-collection"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=FkklG9MA0vM"
    }
  },
  "minecraft": {
    "title": "Minecraft",
    "developer": "Mojang Studios",
    "publisher": "Mojang Studios",
    "releaseDate": "November 18, 2011",
    "description": "Minecraft is a sandbox game allowing players to explore, build, and survive in a blocky, procedurally generated world...",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/573170/header.jpg",
    "category": [
      "PC Games",
      "Top Games"
    ],
    "images": [
      "https://cdn.cloudflare.steamstatic.com/steam/apps/573170/ss_1.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/573170/ss_2.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/573170/ss_3.jpg"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 10",
        "Processor: Intel Core i3 or AMD A8",
        "Memory: 4 GB RAM",
        "Graphics: Nvidia GeForce 400 Series or AMD Radeon HD 7000 series",
        "Storage: 4 GB available space"
      ],
      "recommended": [
        "OS: Windows 10",
        "Processor: Intel Core i5 or AMD Ryzen 5",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce 700 Series or AMD Radeon Rx 200 Series",
        "Storage: 4 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Terraria",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/105600/header.jpg",
        "slug": "terraria"
      },
      {
        "title": "Stardew Valley",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/header.jpg",
        "slug": "stardew-valley"
      },
      {
        "title": "Subnautica",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/264710/header.jpg",
        "slug": "subnautica"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=MmB9b5njVbA"
    }
  },
  "valorant": {
    "title": "Valorant",
    "developer": "Riot Games",
    "publisher": "Riot Games",
    "releaseDate": "June 2, 2020",
    "description": "Valorant is a free-to-play tactical first-person shooter developed by Riot Games. The game features team-based, objective-oriented gameplay where players select from a roster of unique characters, each with their own abilities. Players compete in 5v5 matches where one team attempts to plant a bomb while the other team defends...",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1431050/header.jpg",
    "category": [
      "PC Games",
      "Top Games"
    ],
    "images": [
      "https://cdn.cloudflare.steamstatic.com/steam/apps/1431050/ss_1.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/1431050/ss_2.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/1431050/ss_3.jpg"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7/8/10 (64-bit)",
        "Processor: Intel Core 2 Duo E8400",
        "Memory: 4 GB RAM",
        "Graphics: Intel HD 3000",
        "Storage: 7 GB available space"
      ],
      "recommended": [
        "OS: Windows 7/8/10 (64-bit)",
        "Processor: Intel i3-4150",
        "Memory: 4 GB RAM",
        "Graphics: Geforce GT 730",
        "Storage: 7 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Counter-Strike: Global Offensive",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/730/header.jpg",
        "slug": "counter-strike-global-offensive"
      },
      {
        "title": "Overwatch",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/411010/header.jpg",
        "slug": "overwatch"
      },
      {
        "title": "Paladins",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/header.jpg",
        "slug": "paladins"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=lWr6dhTcu-E"
    }
  },
  "stardew-valley": {
    "title": "Stardew Valley",
    "developer": "ConcernedApe",
    "publisher": "ConcernedApe",
    "releaseDate": "February 26, 2016",
    "description": "Stardew Valley is a farming simulation RPG where players inherit a run-down farm and work to restore it to its former glory. The game offers various activities like planting crops, fishing, raising animals, and exploring caves. As players build relationships with the townspeople, they can also take on quests, attend events, and participate in festivals...",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/header.jpg",
    "category": [
      "PC Games",
      "Top Games"
    ],
    "images": [
      "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/ss_1.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/ss_2.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/ss_3.jpg"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 or higher",
        "Processor: 2 GHz",
        "Memory: 2 GB RAM",
        "Graphics: 256 MB VRAM",
        "Storage: 500 MB available space"
      ],
      "recommended": [
        "OS: Windows 10",
        "Processor: 2.5 GHz",
        "Memory: 4 GB RAM",
        "Graphics: 512 MB VRAM",
        "Storage: 500 MB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Animal Crossing: New Horizons",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1693850/header.jpg",
        "slug": "animal-crossing-new-horizons"
      },
      {
        "title": "My Time at Portia",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/666140/header.jpg",
        "slug": "my-time-at-portia"
      },
      {
        "title": "Farm Together",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/699190/header.jpg",
        "slug": "farm-together"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=ot7uXNQskhs"
    }
  },
  "civilization-vi": {
    "title": "Civilization VI",
    "developer": "Firaxis Games",
    "publisher": "2K Games",
    "releaseDate": "October 21, 2016",
    "description": "Civilization VI is a turn-based strategy game where players lead a civilization from the Stone Age to the Information Age. Players manage resources, conduct diplomacy, build cities, and engage in military conflicts to achieve one of several victory conditions...",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/289070/header.jpg",
    "category": [
      "PC Games",
      "Top Games"
    ],
    "images": [
      "https://cdn.cloudflare.steamstatic.com/steam/apps/289070/ss_1.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/289070/ss_2.jpg",
      "https://cdn.cloudflare.steamstatic.com/steam/apps/289070/ss_3.jpg"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 64-bit",
        "Processor: Intel Core i3 or AMD Phenom II X4 940",
        "Memory: 4 GB RAM",
        "Graphics: Nvidia GeForce 650 or AMD Radeon HD 7770",
        "Storage: 12 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i5 or AMD Ryzen 5",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 960 or AMD Radeon R9 380",
        "Storage: 12 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Civilization V",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/8930/header.jpg",
        "slug": "civilization-v"
      },
      {
        "title": "Stellaris",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/281990/header.jpg",
        "slug": "stellaris"
      },
      {
        "title": "Age of Empires IV",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1466860/header.jpg",
        "slug": "age-of-empires-iv"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=5KdE0p2joJw"
    }
  },
  "age-of-empires-iv": {
    "title": "Age of Empires IV",
    "subtitle": "A Grand Strategy Game",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1466860/header.jpg",
    "description": "Age of Empires IV is a real-time strategy game where players command historical civilizations, build empires, and engage in epic battles.",
    "developer": "Relic Entertainment",
    "publisher": "Xbox Game Studios",
    "releaseDate": "October 28, 2021",
    "category": [
      "PC Games",
      "Strategy Games"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 10",
        "Processor: Intel Core i5-6300U",
        "Memory: 8 GB RAM",
        "Graphics: Intel HD 520",
        "Storage: 50 GB available space"
      ],
      "recommended": [
        "OS: Windows 10",
        "Processor: Intel Core i7-9700",
        "Memory: 16 GB RAM",
        "Graphics: Nvidia GeForce GTX 970",
        "Storage: 50 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Civilization VI",
        "slug": "civilization-vi",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1466860/header.jpg"
      },
      {
        "title": "Stellaris",
        "slug": "stellaris",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1466860/header.jpg"
      },
      {
        "title": "Age of Empires II: Definitive Edition",
        "slug": "age-of-empires-ii-definitive-edition",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1466860/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=O47uUnJjbJc"
    }
  },
  "animal-crossing-new-horizons": {
    "title": "Animal Crossing: New Horizons",
    "subtitle": "A Relaxing Life Simulation",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1693850/header.jpg",
    "description": "Animal Crossing: New Horizons invites players to create their idyllic island life, interacting with villagers, crafting, and designing.",
    "developer": "Nintendo",
    "publisher": "Nintendo",
    "releaseDate": "March 20, 2020",
    "category": [
      "Nintendo Switch",
      "Simulation Games"
    ],
    "systemRequirements": {
      "minimum": [
        "Platform: Nintendo Switch",
        "Storage: 6.2 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Stardew Valley",
        "slug": "stardew-valley",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1693850/header.jpg"
      },
      {
        "title": "My Time at Portia",
        "slug": "my-time-at-portia",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1693850/header.jpg"
      },
      {
        "title": "The Sims 4",
        "slug": "the-sims-4",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1693850/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=_3YNL0OWio0"
    }
  },
  "assassins-creed-odyssey": {
    "title": "Assassin's Creed Odyssey",
    "subtitle": "An Epic Open-World Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/812140/header.jpg",
    "description": "Set in Ancient Greece, Assassin's Creed Odyssey allows players to embark on a journey as a mercenary exploring a vast open world filled with choices and mysteries.",
    "developer": "Ubisoft Quebec",
    "publisher": "Ubisoft",
    "releaseDate": "October 5, 2018",
    "category": [
      "PC Games",
      "PS4",
      "PS5",
      "Action Adventure"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 SP1 or Windows 10 (64-bit only)",
        "Processor: AMD FX 6300 / Intel Core i5 2400",
        "Memory: 8 GB RAM",
        "Graphics: AMD Radeon R9 285 / Nvidia GeForce GTX 660",
        "Storage: 46 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit only)",
        "Processor: AMD Ryzen 5 1400 / Intel Core i7 3770",
        "Memory: 8 GB RAM",
        "Graphics: AMD Radeon R9 290 / Nvidia GeForce GTX 970",
        "Storage: 46 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Red Dead Redemption 2",
        "slug": "red-dead-redemption-2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/812140/header.jpg"
      },
      {
        "title": "Assassin's Creed Valhalla",
        "slug": "assassins-creed-valhalla",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/812140/header.jpg"
      },
      {
        "title": "Far Cry 5",
        "slug": "far-cry-5",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/812140/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=s_SJZSAtLBA"
    }
  },
  "bloodborne": {
    "title": "Bloodborne",
    "subtitle": "A Dark and Gothic RPG",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/349280/header.jpg",
    "description": "Bloodborne challenges players to survive in a gothic city filled with eldritch horrors, blending brutal combat with deep lore.",
    "developer": "FromSoftware",
    "publisher": "Sony Computer Entertainment",
    "releaseDate": "March 24, 2015",
    "category": [
      "PS4",
      "Action RPG"
    ],
    "systemRequirements": {
      "minimum": [
        "Platform: PS4",
        "Storage: 41 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Elden Ring",
        "slug": "elden-ring",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/349280/header.jpg"
      },
      {
        "title": "Dark Souls III",
        "slug": "dark-souls-iii",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/349280/header.jpg"
      },
      {
        "title": "Sekiro: Shadows Die Twice",
        "slug": "sekiro-shadows-die-twice",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/349280/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=G203e1HhixY"
    }
  },
  "civilization-v": {
    "title": "Civilization V",
    "subtitle": "Turn-Based Strategy Masterpiece",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/8930/header.jpg",
    "description": "Civilization V lets players lead a civilization from ancient times to the modern era, focusing on diplomacy, war, and cultural growth.",
    "developer": "Firaxis Games",
    "publisher": "2K Games",
    "releaseDate": "September 21, 2010",
    "category": [
      "PC Games",
      "Strategy Games"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows XP SP3 / Vista SP2 / 7",
        "Processor: Intel Core 2 Duo 1.8 GHz or AMD Athlon X2 64 2.0 GHz",
        "Memory: 2 GB RAM",
        "Graphics: Nvidia GeForce 7900 / ATI Radeon HD 2600 XT",
        "Storage: 8 GB available space"
      ],
      "recommended": [
        "OS: Windows Vista SP2 / 7",
        "Processor: Intel Core 2 Quad 3.0 GHz or AMD Phenom II X4",
        "Memory: 4 GB RAM",
        "Graphics: Nvidia GeForce GTX 260 or ATI Radeon HD 4850",
        "Storage: 8 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Civilization VI",
        "slug": "civilization-vi",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/8930/header.jpg"
      },
      {
        "title": "Stellaris",
        "slug": "stellaris",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/8930/header.jpg"
      },
      {
        "title": "Total War: Rome II",
        "slug": "total-war-rome-ii",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/8930/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=qv6UVOQ0F44"
    }
  },
  "counter-strike-global-offensive": {
    "title": "Counter-Strike: Global Offensive",
    "subtitle": "A Competitive FPS Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/730/header.jpg",
    "description": "Counter-Strike: Global Offensive (CS: GO) is the latest installment in the Counter-Strike series, which revolutionized the tactical first-person shooter genre. CS: GO is all about team-based, objective-driven gameplay, where two teams – Terrorists and Counter-Terrorists – battle it out in various missions such as planting or defusing bombs, or rescuing hostages. It features a wide range of weapons, maps, and game modes. The game is known for its competitive nature, with a thriving esports scene and an in-depth ranking system that determines player skill. The gameplay focuses heavily on strategy, communication, and quick reflexes, making it a favorite among professional and casual gamers alike.",
    "developer": "Valve",
    "publisher": "Valve",
    "releaseDate": "August 21, 2012",
    "category": [
      "PC Games",
      "Competitive Games"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7/Vista/XP",
        "Processor: Intel Core 2 Duo E6600 or AMD Phenom X3 8750",
        "Memory: 2 GB RAM",
        "Graphics: Nvidia GeForce 8600/9600GT or ATI Radeon HD2600/3600",
        "Storage: 15 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Valorant",
        "slug": "valorant",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/730/header.jpg"
      },
      {
        "title": "Rainbow Six Siege",
        "slug": "rainbow-six-siege",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/730/header.jpg"
      },
      {
        "title": "Overwatch",
        "slug": "overwatch",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/730/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=edYCtaNueQY"
    }
  },
  "dark-souls-iii": {
    "title": "Dark Souls III",
    "subtitle": "A Challenging RPG Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/374320/header.jpg",
    "description": "Dark Souls III, developed by FromSoftware, is a punishing action RPG that follows in the footsteps of its predecessors with its signature brutal combat and deep lore. Players control a character known as the Ashen One, embarking on a journey through the decaying world of Lothric. The game is renowned for its difficulty, demanding that players master a complex combat system that requires perfect timing and strategy. The intricate world is interconnected, with hidden secrets and lore-rich environments. Boss battles are among the toughest in the genre, each requiring precise tactics and perfect execution. Dark Souls III also introduces a new world-building mechanic and more open exploration than its predecessors, alongside enhanced visuals and a refined combat system.",
    "developer": "FromSoftware",
    "publisher": "Bandai Namco Entertainment",
    "releaseDate": "April 12, 2016",
    "category": [
      "PC Games",
      "PS4",
      "Action RPG"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 SP1 64-bit, Windows 8.1 64-bit, Windows 10 64-bit",
        "Processor: Intel Core i3-2100 / AMD FX-6300",
        "Memory: 4 GB RAM",
        "Graphics: Nvidia GeForce GTX 750 Ti / ATI Radeon HD 7950",
        "Storage: 25 GB available space"
      ],
      "recommended": [
        "OS: Windows 7 SP1 64-bit, Windows 8.1 64-bit, Windows 10 64-bit",
        "Processor: Intel Core i7-3770 / AMD FX-8350",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 970 / ATI Radeon R9 series",
        "Storage: 25 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Elden Ring",
        "slug": "elden-ring",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/374320/header.jpg"
      },
      {
        "title": "Bloodborne",
        "slug": "bloodborne",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/374320/header.jpg"
      },
      {
        "title": "Sekiro: Shadows Die Twice",
        "slug": "sekiro-shadows-die-twice",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/374320/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=_zDZYrIUgKE"
    }
  },
  "deus-ex-mankind-divided": {
    "title": "Deus Ex: Mankind Divided",
    "subtitle": "A Cyberpunk Action Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/337000/header.jpg",
    "description": "Deus Ex: Mankind Divided is a cyberpunk-themed action RPG set in a world where people with augmented abilities are segregated from the general populace. Players take on the role of Adam Jensen, a security specialist with mechanical augmentations, as he fights to expose a vast conspiracy that threatens global security. The game combines stealth, action, and RPG elements, giving players multiple ways to approach objectives – whether through hacking, combat, or persuasion. Its world-building is deep and immersive, with branching storylines that react to player choices. The game features intricate combat mechanics, augmented abilities, and a narrative driven by moral dilemmas.",
    "developer": "Eidos Montreal",
    "publisher": "Square Enix",
    "releaseDate": "August 23, 2016",
    "category": [
      "PC Games",
      "PS4"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7/8/10 (64-bit)",
        "Processor: Intel Core i3-2100 / AMD FX-4100",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 660 / AMD Radeon HD 7870",
        "Storage: 45 GB available space"
      ],
      "recommended": [
        "OS: Windows 7/8/10 (64-bit)",
        "Processor: Intel Core i7-3770 / AMD FX-8350",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 970 / AMD Radeon RX 480",
        "Storage: 45 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Watch Dogs 2",
        "slug": "watch-dogs-2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/337000/header.jpg"
      },
      {
        "title": "Cyberpunk 2077",
        "slug": "cyberpunk-2077",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/337000/header.jpg"
      },
      {
        "title": "Assassin's Creed Syndicate",
        "slug": "assassins-creed-syndicate",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/337000/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=u9KNtnCZDMI"
    }
  },
  "divinity-original-sin-2": {
    "title": "Divinity: Original Sin 2",
    "subtitle": "A Critically Acclaimed RPG",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/435150/header.jpg",
    "description": "Divinity: Original Sin 2 is a modern RPG masterpiece, praised for its deep role-playing elements, turn-based combat system, and exceptional story. Set in a rich fantasy world on the brink of war, players control a party of unique characters, each with their own backstory, abilities, and moral compass. The game features a dynamic narrative where player choices can drastically affect the world and story, from politics to relationships and combat outcomes. With a fully realized open world, stunning graphics, and intricate dialogue choices, the game offers immense replayability. The cooperative multiplayer mode allows players to form teams and tackle quests together, making every playthrough a unique experience.",
    "developer": "Larian Studios",
    "publisher": "Larian Studios",
    "releaseDate": "September 14, 2017",
    "category": [
      "PC Games",
      "PS4",
      "Co-op RPG"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 / 8 / 10 (64-bit)",
        "Processor: Intel Core i5 or AMD Phenom II X4",
        "Memory: 4 GB RAM",
        "Graphics: Nvidia GeForce GTX 550 or ATI Radeon HD 6xxx series",
        "Storage: 50 GB available space"
      ],
      "recommended": [
        "OS: Windows 7 / 8 / 10 (64-bit)",
        "Processor: Intel Core i7-3770 / AMD FX-8350",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 780 / ATI Radeon RX 480",
        "Storage: 50 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Pillars of Eternity II: Deadfire",
        "slug": "pillars-of-eternity-ii-deadfire",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/435150/header.jpg"
      },
      {
        "title": "Baldur's Gate III",
        "slug": "baldurs-gate-iii",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/435150/header.jpg"
      },
      {
        "title": "The Witcher 3: Wild Hunt",
        "slug": "the-witcher-3-wild-hunt",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/435150/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=8hFwJ7ZqZ4M"
    }
  },
  "dragon-age-inquisition": {
    "title": "Dragon Age: Inquisition",
    "subtitle": "An Immersive Fantasy RPG",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1222690/header.jpg",
    "description": "Dragon Age: Inquisition is a sprawling RPG set in the world of Thedas, where players control the Inquisitor, a leader tasked with closing the breach between the world and the chaos of the Fade. Players must navigate political intrigue, battle dangerous enemies, and explore a vast open world filled with danger and mystery. The game offers a highly customizable experience with choices that directly impact the story, from dialogue options to combat strategies. The game also features tactical combat, where players can pause the action to issue commands, as well as real-time action for those who prefer a more hands-on approach.",
    "developer": "BioWare",
    "publisher": "Electronic Arts",
    "releaseDate": "November 18, 2014",
    "category": [
      "PC Games",
      "PS4",
      "PS5"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 64-bit",
        "Processor: Intel Core i5-750 / AMD Phenom II X4 955",
        "Memory: 4 GB RAM",
        "Graphics: Nvidia GeForce GTX 460 / ATI Radeon HD 6850",
        "Storage: 26 GB available space"
      ],
      "recommended": [
        "OS: Windows 7 64-bit",
        "Processor: Intel Core i7-3770 / AMD FX-8350",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 770 / ATI Radeon RX 480",
        "Storage: 26 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "The Witcher 3: Wild Hunt",
        "slug": "the-witcher-3-wild-hunt",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1222690/header.jpg"
      },
      {
        "title": "Skyrim Special Edition",
        "slug": "skyrim-special-edition",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1222690/header.jpg"
      },
      {
        "title": "Mass Effect: Legendary Edition",
        "slug": "mass-effect-legendary-edition",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1222690/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=JZkqO_mQYrI"
    }
  },
  "doom-2016": {
    "title": "DOOM (2016)",
    "subtitle": "Fast-Paced FPS Action",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/379720/header.jpg",
    "description": "DOOM (2016) is a reboot of the iconic DOOM series, focusing on fast-paced, brutal combat with a heavy emphasis on movement and destruction. Players take control of the Doom Slayer, a legendary warrior tasked with saving Earth from demonic invasion. The game is known for its fluid combat system, where players chain together gunplay, chainsaw attacks, and power-ups to obliterate waves of enemies. DOOM (2016) also introduces the “Glory Kill” mechanic, allowing players to perform brutal finishing moves on weakened enemies. The game’s level design is fast, linear, and filled with hidden secrets and upgrades.",
    "developer": "id Software",
    "publisher": "Bethesda Softworks",
    "releaseDate": "May 13, 2016",
    "category": [
      "PC Games",
      "PS4",
      "FPS Games"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7/8.1/10 (64-bit versions)",
        "Processor: Intel Core i5-2400/AMD FX-8320 or better",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 670 2GB/AMD Radeon HD 7870 2GB or better",
        "Storage: 55 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit versions)",
        "Processor: Intel Core i7-3770/AMD Ryzen 5 1600 or better",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 970 4GB/AMD Radeon RX 480 4GB or better",
        "Storage: 55 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "DOOM Eternal",
        "slug": "doom-eternal",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/379720/header.jpg"
      },
      {
        "title": "Wolfenstein: Youngblood",
        "slug": "wolfenstein-youngblood",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/379720/header.jpg"
      },
      {
        "title": "Halo: The Master Chief Collection",
        "slug": "halo-master-chief-collection",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/379720/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=RO90omga8D4"
    }
  },
  "far-cry-5": {
    "title": "Far Cry 5",
    "subtitle": "A Gripping Open-World Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/552520/header.jpg",
    "description": "Far Cry 5 is an open-world first-person shooter set in a rural Montana county overrun by a religious cult. Players assume the role of a sheriff’s deputy who is tasked with bringing down the cult and saving the locals. The game features a huge open world with diverse environments, wildlife, and vehicles. Players can approach missions in any way they choose, from stealth and strategy to full-on combat. The story is driven by a cast of memorable characters and offers a rich narrative filled with conspiracy, intrigue, and explosive action.",
    "developer": "Ubisoft Montreal",
    "publisher": "Ubisoft",
    "releaseDate": "March 27, 2018",
    "category": [
      "PC Games",
      "PS4",
      "PS5"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 SP1, Windows 8.1, Windows 10 (64-bit versions)",
        "Processor: Intel Core i5-2400 @ 3.1 GHz or AMD FX-6300 @ 3.5 GHz",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 670 or AMD R9 270",
        "Storage: 40 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit versions)",
        "Processor: Intel Core i7-4770 @ 3.4 GHz or AMD Ryzen 5 1600 @ 3.2 GHz",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 970 or AMD R9 290X",
        "Storage: 40 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Assassin's Creed Odyssey",
        "slug": "assassins-creed-odyssey",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/552520/header.jpg"
      },
      {
        "title": "Red Dead Redemption 2",
        "slug": "red-dead-redemption-2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/552520/header.jpg"
      },
      {
        "title": "Watch Dogs: Legion",
        "slug": "watch-dogs-legion",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/552520/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=-JZ_moituIo"
    }
  },
  "farm-together": {
    "title": "Farm Together",
    "subtitle": "A Cooperative Farming Simulator",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/699190/header.jpg",
    "description": "Farm Together is a farming simulator where players build and maintain their farms, plant crops, and raise animals. The game features cooperative multiplayer, where players can join each other’s farms, help with tasks, and earn rewards together. Players can design their farms however they like, planting crops, building structures, and even participating in various mini-games. The game is designed to be relaxing and stress-free, with no penalties for taking breaks. It offers a seamless multiplayer experience and a variety of customization options to make each farm unique.",
    "developer": "Milkstone Studios",
    "publisher": "Milkstone Studios",
    "releaseDate": "November 21, 2018",
    "category": [
      "PC Games",
      "PS4",
      "Co-op Games"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7/8/10 (64-bit versions)",
        "Processor: Intel Core i3 or AMD A8",
        "Memory: 4 GB RAM",
        "Graphics: Nvidia GeForce 400 Series or AMD Radeon HD 7000 series",
        "Storage: 4 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit versions)",
        "Processor: Intel Core i5 or AMD Ryzen 5",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce 700 Series or AMD Radeon RX 200 Series",
        "Storage: 4 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Stardew Valley",
        "slug": "stardew-valley",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/699190/header.jpg"
      },
      {
        "title": "Animal Crossing: New Horizons",
        "slug": "animal-crossing-new-horizons",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/699190/header.jpg"
      },
      {
        "title": "My Time at Portia",
        "slug": "my-time-at-portia",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/699190/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=6X5k2d1tIe8"
    }
  },
  "grand-theft-auto-v": {
    "title": "Grand Theft Auto V",
    "subtitle": "A Modern Open-World Masterpiece",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/271590/header.jpg",
    "description": "Grand Theft Auto V is an open-world action-adventure game set in the fictional city of Los Santos. Players take on the roles of three protagonists – Michael, Trevor, and Franklin – and carry out a series of high-stakes heists. The game is known for its rich narrative, sprawling open world, and varied gameplay. Players can engage in a variety of activities, from heists and firefights to sports and entertainment. The game also features an online multiplayer mode, where players can create and participate in missions, races, and other events.",
    "developer": "Rockstar North",
    "publisher": "Rockstar Games",
    "releaseDate": "April 14, 2015",
    "category": [
      "PC Games",
      "PS4",
      "PS5",
      "Open-World Games"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7/8/10 (64-bit versions)",
        "Processor: Intel Core 2 Quad CPU Q6600 @ 2.40GHz (4 CPUs) / AMD Phenom 9850 Quad-Core (4 CPUs) @ 2.5GHz",
        "Memory: 4 GB RAM",
        "Graphics: Nvidia 9800 GT 1GB / AMD HD 4870 1GB",
        "Storage: 72 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit versions)",
        "Processor: Intel Core i5 3470 @ 3.2GHz (4 CPUs) / AMD X8 FX-8350 @ 4GHz (8 CPUs)",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GTX 660 2GB / AMD HD7870 2GB",
        "Storage: 72 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Red Dead Redemption 2",
        "slug": "red-dead-redemption-2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/271590/header.jpg"
      },
      {
        "title": "Watch Dogs: Legion",
        "slug": "watch-dogs-legion",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/271590/header.jpg"
      },
      {
        "title": "Cyberpunk 2077",
        "slug": "cyberpunk-2077",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/271590/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=QkkoHAzjnUs"
    }
  },
  "halo-master-chief-collection": {
    "title": "Halo: The Master Chief Collection",
    "subtitle": "A Legendary FPS Collection",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/976730/header.jpg",
    "description": "Halo: The Master Chief Collection is a compilation of all the main Halo games, including remastered versions and additional content. Players can experience the story of Master Chief, a super-soldier in a futuristic world, fighting against alien forces known as the Covenant. The collection includes campaigns from various Halo titles, including Halo: Combat Evolved, Halo 2, Halo 3, and Halo 4, along with multiplayer modes. The game also features remastered visuals, improved mechanics, and a larger online community. It’s the ultimate package for Halo fans, offering both nostalgic content and a modern experience.",
    "developer": "343 Industries",
    "publisher": "Xbox Game Studios",
    "releaseDate": "December 3, 2019",
    "category": [
      "PC Games",
      "FPS Games"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 (64-bit)",
        "Processor: Intel Core i5-4440 / AMD Ryzen 5 1600",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 1050 Ti / AMD Radeon RX 570",
        "Storage: 25 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i7-7700K / AMD Ryzen 7 1700X",
        "Memory: 16 GB RAM",
        "Graphics: Nvidia GeForce GTX 1070 / AMD Radeon RX Vega 56",
        "Storage: 25 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "DOOM (2016)",
        "slug": "doom-2016",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/976730/header.jpg"
      },
      {
        "title": "Overwatch",
        "slug": "overwatch",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/976730/header.jpg"
      },
      {
        "title": "Destiny 2",
        "slug": "destiny-2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/976730/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=YykjpeuMNEk"
    }
  },
  "watch-dogs-legion": {
    "title": "Watch Dogs: Legion",
    "subtitle": "A Revolutionary Open-World Action Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/978800/header.jpg",
    "description": "Watch Dogs: Legion is an open-world action game that takes place in a near-future London, controlled by an oppressive regime. The game introduces the ability to recruit and play as virtually any NPC in the world. Players control a resistance group aiming to free London from authoritarian control, and every NPC in the game has a unique backstory, skills, and attributes. The game’s story is driven by the player’s actions and decisions, allowing for immense flexibility in how the world is navigated. From stealthy infiltration to open combat, players can approach missions in their own way, adding great replay value and personalization.",
    "developer": "Ubisoft Toronto",
    "publisher": "Ubisoft",
    "releaseDate": "October 29, 2020",
    "category": [
      "PC Games",
      "PS4",
      "PS5",
      "Open-World Games"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i5-4460 / AMD Ryzen 3 1200",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 970 / AMD Radeon RX 480",
        "Storage: 45 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i7-4790 / AMD Ryzen 5 1600",
        "Memory: 16 GB RAM",
        "Graphics: Nvidia GeForce GTX 1080 / AMD Radeon RX Vega 64",
        "Storage: 45 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Assassin's Creed Odyssey",
        "slug": "assassins-creed-odyssey",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/978800/header.jpg"
      },
      {
        "title": "Red Dead Redemption 2",
        "slug": "red-dead-redemption-2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/978800/header.jpg"
      },
      {
        "title": "Grand Theft Auto V",
        "slug": "grand-theft-auto-v",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/978800/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=sqZYVYm8pz4"
    }
  },
  "wolfenstein-youngblood": {
    "title": "Wolfenstein: Youngblood",
    "subtitle": "Co-Op First-Person Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1045770/header.jpg",
    "description": "Wolfenstein: Youngblood is a first-person shooter set in an alternate history where Nazi forces have taken over the world. The game follows BJ Blazkowicz’s twin daughters, Jess and Soph, as they embark on a mission to find their father and fight Nazi forces in a 1980s Paris. This entry in the Wolfenstein series introduces cooperative multiplayer, allowing players to team up with a friend for the first time in the series. The game blends classic FPS gameplay with RPG elements, offering various upgrades, weapons, and abilities to defeat Nazi forces.",
    "developer": "MachineGames",
    "publisher": "Bethesda Softworks",
    "releaseDate": "July 26, 2019",
    "category": [
      "PC Games",
      "PS4",
      "Co-op Games"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 64-bit",
        "Processor: Intel Core i5-3570K / AMD Ryzen 5 1400",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 770 / AMD Radeon R9 290X",
        "Storage: 25 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i7-4770 / AMD Ryzen 5 1600",
        "Memory: 16 GB RAM",
        "Graphics: Nvidia GeForce GTX 1070 / AMD Radeon RX Vega 56",
        "Storage: 25 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "DOOM Eternal",
        "slug": "doom-eternal",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1045770/header.jpg"
      },
      {
        "title": "Metro Exodus",
        "slug": "metro-exodus",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1045770/header.jpg"
      },
      {
        "title": "Call of Duty: Warzone",
        "slug": "call-of-duty-warzone",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1045770/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=0ga4t7i5QmA"
    }
  },
  "terraria": {
    "title": "Terraria",
    "subtitle": "A 2D Sandbox Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/105600/header.jpg",
    "description": "Terraria is a 2D sandbox game that mixes exploration, building, and combat. Players can dig, build, fight, and explore a procedurally generated world full of treasures and enemies. The game features various biomes, from forests to deserts to underground caverns. Players can craft items, gather resources, and defeat bosses. Terraria also includes multiplayer, allowing friends to team up for adventures or create shared worlds. The game’s simple mechanics are enhanced by the creative freedom it offers, allowing players to build complex structures or engage in thrilling battles.",
    "developer": "Re-Logic",
    "publisher": "Re-Logic",
    "releaseDate": "May 16, 2011",
    "category": [
      "PC Games",
      "PS4",
      "Sandbox Games"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7/8/10",
        "Processor: 1.6 GHz",
        "Memory: 2 GB RAM",
        "Graphics: 128 MB Video Memory",
        "Storage: 200 MB available space"
      ],
      "recommended": [
        "OS: Windows 7/8/10",
        "Processor: 2.5 GHz",
        "Memory: 4 GB RAM",
        "Graphics: 256 MB Video Memory",
        "Storage: 200 MB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Minecraft",
        "slug": "minecraft",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/105600/header.jpg"
      },
      {
        "title": "Starbound",
        "slug": "starbound",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/105600/header.jpg"
      },
      {
        "title": "Stardew Valley",
        "slug": "stardew-valley",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/105600/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=H77Zfzy4LWw"
    }
  },
  "subnautica": {
    "title": "Subnautica",
    "subtitle": "A Deep Sea Exploration Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/264710/header.jpg",
    "description": "Subnautica is an open-world survival game set on an alien ocean planet. Players control a character who survives a crash landing on the planet and must gather resources, craft equipment, and explore the ocean depths. The game features a rich environment filled with various biomes, from coral reefs to dark, dangerous underwater caves. Players must manage hunger, thirst, and oxygen while exploring the world and uncovering the mysteries of the planet. The game combines elements of exploration, crafting, and storytelling in a unique and immersive way.",
    "developer": "Unknown Worlds Entertainment",
    "publisher": "Unknown Worlds Entertainment",
    "releaseDate": "January 23, 2018",
    "category": [
      "PC Games",
      "PS4",
      "Survival Games"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 64-bit",
        "Processor: Intel Core i5-4690 / AMD A10-7800",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 550 Ti / AMD Radeon HD 7750",
        "Storage: 20 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i7-6700 / AMD Ryzen 5 1600",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 1060 / AMD Radeon RX 580",
        "Storage: 20 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Terraria",
        "slug": "terraria",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/264710/header.jpg"
      },
      {
        "title": "No Man's Sky",
        "slug": "no-mans-sky",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/264710/header.jpg"
      },
      {
        "title": "Minecraft",
        "slug": "minecraft",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/264710/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=Rz2SNm8VguE"
    }
  },
  "my-time-at-portia": {
    "title": "My Time at Portia",
    "subtitle": "A Charming Life-Simulation RPG",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/666140/header.jpg",
    "description": "My Time at Portia is a delightful life-simulation RPG set in a post-apocalyptic world where humanity is rebuilding civilization. Players take on the role of a workshop owner in the vibrant town of Portia, tasked with restoring the workshop, crafting various items, and helping the town thrive. The game features an open-world experience with farming, fishing, mining, dungeon exploration, and relationship-building mechanics. With its heartwarming story, colorful visuals, and engaging gameplay, My Time at Portia offers a relaxing yet immersive experience for players who enjoy crafting, exploration, and social interactions.",
    "developer": "Pathea Games",
    "publisher": "Team17",
    "releaseDate": "January 15, 2019",
    "category": [
      "PC Games",
      "PS4",
      "Nintendo Switch",
      "Life Simulation"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 / 8 / 10 (64-bit)",
        "Processor: Intel Core i3-2100 or AMD FX-6300",
        "Memory: 6 GB RAM",
        "Graphics: Nvidia GeForce GTX 660 or AMD Radeon HD 7850",
        "Storage: 6 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i7-2600 or AMD Ryzen 5 1400",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 960 or AMD Radeon R9 280",
        "Storage: 10 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Stardew Valley",
        "slug": "stardew-valley",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/666140/header.jpg"
      },
      {
        "title": "Animal Crossing: New Horizons",
        "slug": "animal-crossing-new-horizons",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/666140/header.jpg"
      },
      {
        "title": "Farm Together",
        "slug": "farm-together",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/666140/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=6zVjLZ6l5e4"
    }
  },
  "overwatch": {
    "title": "Overwatch",
    "subtitle": "A Team-Based Multiplayer Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/411010/header.jpg",
    "description": "Overwatch is a fast-paced, team-based first-person shooter developed by Blizzard Entertainment. Players choose from a diverse roster of heroes, each with unique abilities and roles, to compete in objective-based matches. The game emphasizes teamwork and strategy, with roles such as tank, damage, and support characters working together to achieve victory. Overwatch features a variety of game modes, including Quick Play, Competitive Play, and Arcade, as well as seasonal events with exclusive skins and challenges. With dynamic maps, engaging character interactions, and a constantly evolving meta, Overwatch remains one of the most beloved multiplayer shooters in gaming.",
    "developer": "Blizzard Entertainment",
    "publisher": "Blizzard Entertainment",
    "releaseDate": "May 24, 2016",
    "category": [
      "PC Games",
      "PS4",
      "PS5",
      "FPS",
      "Multiplayer"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 / 8 / 10 (64-bit)",
        "Processor: Intel Core i3 or AMD Phenom X3 8650",
        "Memory: 4 GB RAM",
        "Graphics: Nvidia GeForce GTX 460 / AMD Radeon HD 4850",
        "Storage: 30 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i5 / AMD Phenom II X3, X4",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 660 / AMD Radeon HD 7950",
        "Storage: 50 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Valorant",
        "slug": "valorant",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/411010/header.jpg"
      },
      {
        "title": "Counter-Strike: Global Offensive",
        "slug": "counter-strike-global-offensive",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/411010/header.jpg"
      },
      {
        "title": "Paladins",
        "slug": "paladins",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/411010/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=FqnKB22pOC0"
    }
  },
  "paladins": {
    "title": "Paladins",
    "subtitle": "A Free-to-Play Hero Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/header.jpg",
    "description": "Paladins is a free-to-play team-based shooter that combines fast-paced action with strategic depth. Players select from a wide range of champions, each with their own unique abilities and playstyles. The game features a deck-building system that allows players to customize their abilities, adding an extra layer of strategy. With multiple game modes, including Siege, Onslaught, and Team Deathmatch, Paladins offers an engaging competitive experience. Its vibrant fantasy setting and accessible gameplay make it a great alternative to Overwatch and other hero-based shooters.",
    "developer": "Evil Mojo Games",
    "publisher": "Hi-Rez Studios",
    "releaseDate": "September 16, 2016",
    "category": [
      "PC Games",
      "PS4",
      "Nintendo Switch",
      "FPS",
      "Multiplayer"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 / 8 / 10 (64-bit)",
        "Processor: Intel Core 2 Duo 2.4 GHz / AMD Athlon X2 2.8 GHz",
        "Memory: 4 GB RAM",
        "Graphics: Nvidia GeForce 8800 GT / AMD Radeon 3870",
        "Storage: 30 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i5-750 / AMD Phenom II X4 965",
        "Memory: 6 GB RAM",
        "Graphics: Nvidia GeForce GTX 660 / AMD Radeon HD 7950",
        "Storage: 40 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Overwatch",
        "slug": "overwatch",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/header.jpg"
      },
      {
        "title": "Valorant",
        "slug": "valorant",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/header.jpg"
      },
      {
        "title": "Counter-Strike: Global Offensive",
        "slug": "counter-strike-global-offensive",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=dEwEC2MKgeQ"
    }
  },
  "sekiro-shadows-die-twice": {
    "title": "Sekiro: Shadows Die Twice",
    "subtitle": "A Hardcore Samurai Action-Adventure Game",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/814380/header.jpg",
    "description": "Sekiro: Shadows Die Twice is an action-adventure game set in Sengoku-era Japan, where players take control of a shinobi known as Wolf. Tasked with rescuing his kidnapped lord, Wolf must navigate treacherous environments, battle deadly foes, and master a unique combat system based on precision, deflection, and counters. Unlike FromSoftware’s Souls games, Sekiro focuses on fast, skill-based combat with a strong emphasis on swordplay and stealth. The game features stunning visuals, immersive world-building, and brutal difficulty, rewarding patience and mastery. With multiple endings, Sekiro offers high replay value for players who seek a challenging experience.",
    "developer": "FromSoftware",
    "publisher": "Activision",
    "releaseDate": "March 22, 2019",
    "category": [
      "PC Games",
      "PS4",
      "Action Adventure"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 / 8 / 10 (64-bit)",
        "Processor: Intel Core i3-2100 / AMD FX-6300",
        "Memory: 4 GB RAM",
        "Graphics: Nvidia GeForce GTX 760 / AMD Radeon HD 7950",
        "Storage: 25 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i5-2500K / AMD Ryzen 5 1400",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 970 / AMD Radeon RX 570",
        "Storage: 25 GB available space"
      ]
    },
    "relatedGames": [
      {
        "title": "Dark Souls III",
        "slug": "dark-souls-iii",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/814380/header.jpg"
      },
      {
        "title": "Bloodborne",
        "slug": "bloodborne",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/814380/header.jpg"
      },
      {
        "title": "Nioh",
        "slug": "nioh",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/814380/header.jpg"
      }
    ],
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=rXMX4YJ7Lks"
    }
  },
  "age-of-empires-ii-definitive-edition": {
    "title": "Age of Empires II: Definitive Edition",
    "subtitle": "The Classic RTS Reborn",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/813780/header.jpg",
    "description": "Age of Empires II: Definitive Edition is the remastered version of the classic real-time strategy game, offering enhanced graphics, all the previous expansions, and new content. Players can build civilizations, manage resources, and engage in tactical warfare across multiple historical campaigns. With an expanded multiplayer mode, AI improvements, and new civilizations, this edition breathes new life into the legendary RTS that has stood the test of time.",
    "developer": "Forgotten Empires",
    "publisher": "Xbox Game Studios",
    "releaseDate": "November 14, 2019",
    "category": [
      "PC Games",
      "Strategy",
      "RTS"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i5 or AMD Ryzen 5",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 760 / AMD Radeon RX 560",
        "Storage: 30 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i7 / AMD Ryzen 7",
        "Memory: 16 GB RAM",
        "Graphics: Nvidia GeForce GTX 1060 / AMD Radeon RX 580",
        "Storage: 30 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=QOa0RuV2B4Y"
    },
    "relatedGames": [
      {
        "title": "Age of Empires III: Definitive Edition",
        "slug": "age-of-empires-iii-definitive-edition",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/813780/header.jpg"
      },
      {
        "title": "Empire Earth",
        "slug": "empire-earth",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/813780/header.jpg"
      },
      {
        "title": "Civilization VI",
        "slug": "civilization-vi",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/813780/header.jpg"
      }
    ]
  },
  "the-sims-4": {
    "title": "The Sims 4",
    "subtitle": "Create and Control Your World",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1222670/header.jpg",
    "description": "The Sims 4 is a life simulation game that allows players to create and control virtual people, build homes, and shape their lives. With various expansion packs and customization options, players can create unique Sims, furnish homes, pursue careers, and develop relationships. The game offers a rich variety of activities, from career advancement to hobby exploration, all while navigating the ups and downs of life. The Sims 4 continues to expand with new features and content through regular updates and expansions.",
    "developer": "Maxis",
    "publisher": "Electronic Arts",
    "releaseDate": "September 2, 2014",
    "category": [
      "PC Games",
      "Simulation",
      "Life Simulation"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 64-bit",
        "Processor: Intel Core i5-750 or AMD Athlon X4 840",
        "Memory: 4 GB RAM",
        "Graphics: Nvidia GeForce GTX 650 or AMD Radeon HD 7850",
        "Storage: 10 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i5-6600 or AMD Ryzen 5 2400G",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 970 or AMD Radeon RX 670",
        "Storage: 18 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=3VkY3O0_pTU"
    },
    "relatedGames": [
      {
        "title": "The Sims 3",
        "slug": "the-sims-3",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1222670/header.jpg"
      },
      {
        "title": "SimCity",
        "slug": "simcity",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1222670/header.jpg"
      },
      {
        "title": "Stardew Valley",
        "slug": "stardew-valley",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1222670/header.jpg"
      }
    ]
  },
  "assassins-creed-valhalla": {
    "title": "Assassin's Creed Valhalla",
    "subtitle": "An Epic Viking Adventure",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/976730/header.jpg",
    "description": "Assassin’s Creed Valhalla takes players into the Viking age, where they play as Eivor, a Viking warrior on a quest to build a new home in England. The game features open-world exploration, brutal combat, and complex storylines with decisions that shape the world. Players can raid settlements, explore England and Norway, and engage in deep RPG mechanics such as leveling up, gear customization, and building alliances. Valhalla continues the series’ tradition of blending history with fiction and introduces new features like settlement-building and naval exploration.",
    "developer": "Ubisoft Montreal",
    "publisher": "Ubisoft",
    "releaseDate": "November 10, 2020",
    "category": [
      "PC Games",
      "PS4",
      "PS5",
      "Action RPG"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i5-4460 or AMD Ryzen 3 1200",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 960 or AMD Radeon RX 470",
        "Storage: 50 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i7-6700K or AMD Ryzen 5 3600",
        "Memory: 16 GB RAM",
        "Graphics: Nvidia GeForce GTX 1080 or AMD Radeon RX Vega 56",
        "Storage: 50 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=ssrNcwxALS4"
    },
    "relatedGames": [
      {
        "title": "Assassin's Creed Origins",
        "slug": "assassins-creed-origins",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/976730/header.jpg"
      },
      {
        "title": "Dark Souls III",
        "slug": "dark-souls-iii",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/976730/header.jpg"
      },
      {
        "title": "The Witcher 3: Wild Hunt",
        "slug": "the-witcher-3-wild-hunt",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/976730/header.jpg"
      }
    ]
  },
  "total-war-rome-ii": {
    "title": "Total War: Rome II",
    "subtitle": "The Epic Strategy of Ancient Rome",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/214950/header.jpg",
    "description": "Total War: Rome II is a grand strategy game set in the ancient Roman era. Players take control of a Roman faction and must manage resources, armies, and diplomacy to conquer the known world. The game features large-scale tactical battles, political maneuvering, and the strategic management of armies and settlements. The game’s expansive campaign map spans across the Mediterranean world, and players must make key decisions about alliances, wars, and governance to expand their empire. With various factions to choose from and deep historical accuracy, Rome II offers a comprehensive strategy experience.",
    "developer": "Creative Assembly",
    "publisher": "Sega",
    "releaseDate": "September 3, 2013",
    "category": [
      "PC Games",
      "Strategy",
      "RTS"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 64-bit",
        "Processor: Intel Core 2 Duo 3.0 GHz or AMD Athlon 64 X2 6400+",
        "Memory: 2 GB RAM",
        "Graphics: Nvidia GeForce GTX 460 or AMD Radeon HD 6850",
        "Storage: 35 GB available space"
      ],
      "recommended": [
        "OS: Windows 7 / 8 64-bit",
        "Processor: Intel Core i5-4570 or AMD Ryzen 5 2400G",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 770 or AMD Radeon R9 290",
        "Storage: 35 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=z2ZOpbSUPVQ"
    },
    "relatedGames": [
      {
        "title": "Total War: Shogun 2",
        "slug": "total-war-shogun-2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/214950/header.jpg"
      },
      {
        "title": "Empire: Total War",
        "slug": "empire-total-war",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/214950/header.jpg"
      },
      {
        "title": "Rome: Total War",
        "slug": "rome-total-war",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/214950/header.jpg"
      }
    ]
  },
  "rainbow-six-siege": {
    "title": "Tom Clancy's Rainbow Six Siege",
    "subtitle": "Tactical Multiplayer Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/359550/header.jpg",
    "description": "Tom Clancy's Rainbow Six Siege is a tactical first-person shooter that emphasizes strategic gameplay, teamwork, and environmental destruction. Players take control of elite operators from various counter-terrorism units around the world. The game offers a variety of modes, including Bomb, Hostage, and Secure Area, with players engaging in intense, close-quarters combat. Siege’s destructible environments allow for dynamic combat, where every wall, floor, and ceiling is a potential access point for attackers and defenders. The game has a thriving esports scene and frequent updates with new operators, maps, and features.",
    "developer": "Ubisoft Montreal",
    "publisher": "Ubisoft",
    "releaseDate": "December 1, 2015",
    "category": [
      "PC Games",
      "PS4",
      "Xbox One",
      "FPS",
      "Multiplayer"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 64-bit",
        "Processor: Intel Core i3-560 or AMD Phenom II X4 945",
        "Memory: 6 GB RAM",
        "Graphics: Nvidia GeForce GTX 460 or AMD Radeon HD 6850",
        "Storage: 61 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i5-7500 or AMD Ryzen 5 1600",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 970 or AMD Radeon RX 480",
        "Storage: 61 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=6wlvYh0h63k"
    },
    "relatedGames": [
      {
        "title": "Counter-Strike: Global Offensive",
        "slug": "counter-strike-global-offensive",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/359550/header.jpg"
      },
      {
        "title": "Overwatch",
        "slug": "overwatch",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/359550/header.jpg"
      },
      {
        "title": "Valorant",
        "slug": "valorant",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/359550/header.jpg"
      }
    ]
  },
  "watch-dogs-2": {
    "title": "Watch Dogs 2",
    "subtitle": "Hack the World, Save the Future",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/447040/header.jpg",
    "description": "Watch Dogs 2 is an open-world action-adventure game where players take control of Marcus Holloway, a young hacker trying to expose a corrupt corporation while uncovering a massive conspiracy. Set in the tech-savvy city of San Francisco, the game allows players to hack into various devices, control vehicles, and manipulate the environment to complete missions. The game combines stealth, combat, and puzzles with an engaging story that tackles issues such as privacy, surveillance, and social inequality.",
    "developer": "Ubisoft Montreal",
    "publisher": "Ubisoft",
    "releaseDate": "November 15, 2016",
    "category": [
      "PC Games",
      "PS4",
      "PS5",
      "Action Adventure"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 64-bit",
        "Processor: Intel Core i5-2400S 2.5GHz or AMD FX-6120",
        "Memory: 6 GB RAM",
        "Graphics: Nvidia GeForce GTX 660 or AMD Radeon HD 7870",
        "Storage: 50 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i7-3770 or AMD FX-8350",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 970 or AMD Radeon RX 480",
        "Storage: 50 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=2GIVVsTKTLg"
    },
    "relatedGames": [
      {
        "title": "Watch Dogs",
        "slug": "watch-dogs",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/447040/header.jpg"
      },
      {
        "title": "Grand Theft Auto V",
        "slug": "grand-theft-auto-v",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/447040/header.jpg"
      },
      {
        "title": "Assassin's Creed IV: Black Flag",
        "slug": "assassins-creed-iv-black-flag",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/447040/header.jpg"
      }
    ]
  },
  "assassins-creed-syndicate": {
    "title": "Assassin's Creed Syndicate",
    "subtitle": "London, 1868 - A War Between Assassins and Templars",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/361310/header.jpg",
    "description": "Assassin’s Creed Syndicate takes place in Victorian London, during a time of industrial revolution and societal upheaval. Players take control of two playable characters: Jacob Frye and his twin sister Evie. Together, they fight to free London from the oppressive rule of the Templar Order while navigating the city’s underworld. The game offers an open-world environment with a variety of activities, including combat, stealth, and exploration. Players can use a range of weapons and gadgets, as well as recruit gang members to take over different territories across the city.",
    "developer": "Ubisoft Quebec",
    "publisher": "Ubisoft",
    "releaseDate": "October 23, 2015",
    "category": [
      "PC Games",
      "PS4",
      "Xbox One",
      "Action Adventure"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 / 8 / 10 (64-bit)",
        "Processor: Intel Core i5-2400s 2.5GHz or AMD FX-6350",
        "Memory: 6 GB RAM",
        "Graphics: Nvidia GeForce GTX 660 or AMD Radeon HD 7870",
        "Storage: 50 GB available space"
      ],
      "recommended": [
        "OS: Windows 7 / 8 / 10 (64-bit)",
        "Processor: Intel Core i7-3770 3.4GHz or AMD FX-8350",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 760 or AMD Radeon RX 470",
        "Storage: 50 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=xzCEdSKMkdU"
    },
    "relatedGames": [
      {
        "title": "Assassin's Creed IV: Black Flag",
        "slug": "assassins-creed-iv-black-flag",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/361310/header.jpg"
      },
      {
        "title": "Watch Dogs 2",
        "slug": "watch-dogs-2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/361310/header.jpg"
      },
      {
        "title": "Batman: Arkham Knight",
        "slug": "batman-arkham-knight",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/361310/header.jpg"
      }
    ]
  },
  "pillars-of-eternity-ii-deadfire": {
    "title": "Pillars of Eternity II: Deadfire",
    "subtitle": "An Epic RPG Adventure in the Vast Ocean",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/560130/header.jpg",
    "description": "Pillars of Eternity II: Deadfire is a sequel to the critically acclaimed RPG set in the world of Eora. Players take control of the Watcher, a character who has the ability to see and communicate with souls. The game features an open-world exploration of the Deadfire Archipelago, a region filled with various islands to explore, and diverse factions vying for power. Players can engage in tactical combat, recruit companions, and make critical decisions that affect the outcome of the story. The game offers an immersive experience with deep lore, intricate dialogues, and multiple endings.",
    "developer": "Obsidian Entertainment",
    "publisher": "Versus Evil",
    "releaseDate": "May 8, 2018",
    "category": [
      "PC Games",
      "RPG"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 (64-bit)",
        "Processor: Intel Core i5-6500 or AMD Ryzen 3 2200G",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 650 or AMD Radeon HD 7730",
        "Storage: 30 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i7-7700K or AMD Ryzen 5 1600X",
        "Memory: 16 GB RAM",
        "Graphics: Nvidia GeForce GTX 1060 or AMD Radeon RX 580",
        "Storage: 30 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=4H9yVjJZ4l8"
    },
    "relatedGames": [
      {
        "title": "Divinity: Original Sin 2",
        "slug": "divinity-original-sin-2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/560130/header.jpg"
      },
      {
        "title": "Baldur's Gate III",
        "slug": "baldurs-gate-iii",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/560130/header.jpg"
      },
      {
        "title": "Tyranny",
        "slug": "tyranny",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/560130/header.jpg"
      }
    ]
  },
  "baldurs-gate-iii": {
    "title": "Baldur's Gate III",
    "subtitle": "A New RPG in the Legendary Franchise",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1086940/header.jpg",
    "description": "Baldur’s Gate III is the long-awaited return to the iconic RPG series set in the Dungeons & Dragons universe. The game offers deep narrative choices, turn-based combat, and expansive character customization. Players control a group of adventurers who must navigate the complex and dangerous world of Faerûn while dealing with the influence of a powerful and sinister force. The game features an engaging single-player story, as well as multiplayer modes where players can team up to explore the world together. The game emphasizes player choice, with consequences that ripple through the story.",
    "developer": "Larian Studios",
    "publisher": "Larian Studios",
    "releaseDate": "October 6, 2020",
    "category": [
      "PC Games",
      "RPG",
      "Turn-Based Combat"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i5-4690 or AMD Ryzen 3 3200G",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 970 or AMD Radeon RX 480",
        "Storage: 70 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i7-7700K or AMD Ryzen 5 3600X",
        "Memory: 16 GB RAM",
        "Graphics: Nvidia GeForce GTX 1660 or AMD Radeon RX 580",
        "Storage: 70 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=WJ3L1Z7lFw4"
    },
    "relatedGames": [
      {
        "title": "Pillars of Eternity II: Deadfire",
        "slug": "pillars-of-eternity-ii-deadfire",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1086940/header.jpg"
      },
      {
        "title": "Divinity: Original Sin 2",
        "slug": "divinity-original-sin-2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1086940/header.jpg"
      },
      {
        "title": "Dragon Age: Inquisition",
        "slug": "dragon-age-inquisition",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1086940/header.jpg"
      }
    ]
  },
  "skyrim-special-edition": {
    "title": "The Elder Scrolls V: Skyrim Special Edition",
    "subtitle": "The Legendary RPG Reborn in High Definition",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/489830/header.jpg",
    "description": "The Elder Scrolls V: Skyrim Special Edition is a remastered version of the legendary open-world RPG, Skyrim. With improved graphics, enhanced features, and all the DLC expansions, the Special Edition offers the ultimate Skyrim experience. Players can explore the vast open world of Skyrim, interact with NPCs, join factions, and engage in combat and magic. As the Dragonborn, players must stop the ancient dragon Alduin from destroying the world. Skyrim is known for its rich story, deep world-building, and freedom of choice, making it one of the most beloved RPGs of all time.",
    "developer": "Bethesda Game Studios",
    "publisher": "Bethesda Softworks",
    "releaseDate": "October 28, 2016",
    "category": [
      "PC Games",
      "PS4",
      "Xbox One",
      "RPG"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 (64-bit)",
        "Processor: Intel Core i5-750 or AMD Phenom II X4 955",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 470 or AMD Radeon 6870",
        "Storage: 12 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i7-2600K or AMD Ryzen 5 1500X",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 780 or AMD Radeon RX 470",
        "Storage: 12 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=JSRtYpNRoN0"
    },
    "relatedGames": [
      {
        "title": "The Witcher 3: Wild Hunt",
        "slug": "the-witcher-3-wild-hunt",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/489830/header.jpg"
      },
      {
        "title": "Dragon Age: Inquisition",
        "slug": "dragon-age-inquisition",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/489830/header.jpg"
      },
      {
        "title": "Dark Souls III",
        "slug": "dark-souls-iii",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/489830/header.jpg"
      }
    ]
  },
  "mass-effect-legendary-edition": {
    "title": "Mass Effect Legendary Edition",
    "subtitle": "The Ultimate RPG Trilogy Remastered",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1328670/header.jpg",
    "description": "Mass Effect Legendary Edition is a remastered version of the iconic Mass Effect trilogy, offering improved visuals, enhanced gameplay, and all the downloadable content (DLC) released for the original games. The game follows Commander Shepard as they attempt to stop a galactic threat by uniting various alien races. The game offers deep storylines, character customization, and tactical combat. With updated graphics and smoother gameplay mechanics, Mass Effect Legendary Edition brings the epic sci-fi RPG to modern players.",
    "developer": "BioWare",
    "publisher": "Electronic Arts",
    "releaseDate": "May 14, 2021",
    "category": [
      "PC Games",
      "PS4",
      "Xbox One",
      "RPG"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i5-3570 or AMD Ryzen 3 1300X",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 760 or AMD Radeon RX 560",
        "Storage: 120 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i7-7700 or AMD Ryzen 7 3700X",
        "Memory: 16 GB RAM",
        "Graphics: Nvidia GeForce GTX 1070 or AMD Radeon RX Vega 56",
        "Storage: 120 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=n8i53TtQ6IQ"
    },
    "relatedGames": [
      {
        "title": "The Witcher 3: Wild Hunt",
        "slug": "the-witcher-3-wild-hunt",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1328670/header.jpg"
      },
      {
        "title": "Dragon Age: Inquisition",
        "slug": "dragon-age-inquisition",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1328670/header.jpg"
      },
      {
        "title": "Star Wars: Knights of the Old Republic",
        "slug": "star-wars-knights-of-the-old-republic",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1328670/header.jpg"
      }
    ]
  },
  "destiny-2": {
    "title": "Destiny 2",
    "subtitle": "The Ultimate FPS MMO Experience",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1085660/header.jpg",
    "description": "Destiny 2 is an online multiplayer first-person shooter set in a shared open-world environment. Players take on the role of Guardians, protectors of the last city on Earth, as they fight against various alien enemies, explore different planets, and take part in cooperative and competitive activities. The game features a dynamic progression system, allowing players to level up, obtain new weapons and gear, and join clans for additional multiplayer content. With frequent updates, expansions, and seasonal content, Destiny 2 offers a constantly evolving universe.",
    "developer": "Bungie",
    "publisher": "Bungie",
    "releaseDate": "September 6, 2017",
    "category": [
      "PC Games",
      "FPS",
      "MMO"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7/8/10 (64-bit)",
        "Processor: Intel Core i3-3250 or AMD FX-4350",
        "Memory: 6 GB RAM",
        "Graphics: Nvidia GeForce GTX 660 2GB or AMD Radeon HD 7850 2GB",
        "Storage: 105 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i5-7400 or AMD Ryzen 5 1600X",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 1060 6GB or AMD Radeon RX 580 8GB",
        "Storage: 105 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=hdWkpbPTpmE"
    },
    "relatedGames": [
      {
        "title": "Warframe",
        "slug": "warframe",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1085660/header.jpg"
      },
      {
        "title": "The Division 2",
        "slug": "the-division-2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1085660/header.jpg"
      },
      {
        "title": "Halo: The Master Chief Collection",
        "slug": "halo-master-chief-collection",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1085660/header.jpg"
      }
    ]
  },
  "metro-exodus": {
    "title": "Metro Exodus",
    "subtitle": "A Post-Apocalyptic Survival Shooter",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/412020/header.jpg",
    "description": "Metro Exodus is a first-person shooter set in a post-apocalyptic Russia, where players assume the role of Artyom, a soldier fighting to survive against the remnants of humanity and mutated creatures. The game is a hybrid of open-world exploration and linear storytelling, featuring intense combat, stealth, and survival mechanics. The game’s storyline follows Artyom as he journeys across the Russian landscape, hoping to find a new home while unraveling dark secrets about the state of the world. Metro Exodus offers breathtaking visuals, a haunting atmosphere, and deep narrative elements.",
    "developer": "4A Games",
    "publisher": "Deep Silver",
    "releaseDate": "February 15, 2019",
    "category": [
      "PC Games",
      "PS4",
      "Xbox One",
      "Shooter"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7/8/10 (64-bit)",
        "Processor: Intel Core i5-4440 or AMD Ryzen 3 1200",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 670 2GB or AMD Radeon HD 7870 2GB",
        "Storage: 59 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 (64-bit)",
        "Processor: Intel Core i7-4770 or AMD Ryzen 5 1600",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 1070 8GB or AMD Radeon RX Vega 56 8GB",
        "Storage: 59 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=zxzxE1vE3zY"
    },
    "relatedGames": [
      {
        "title": "Call of Duty: Modern Warfare",
        "slug": "call-of-duty-modern-warfare",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/412020/header.jpg"
      },
      {
        "title": "Far Cry 5",
        "slug": "far-cry-5",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/412020/header.jpg"
      },
      {
        "title": "S.T.A.L.K.E.R. 2",
        "slug": "stalker-2",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/412020/header.jpg"
      }
    ]
  },
  "call-of-duty-warzone": {
    "title": "Call of Duty: Warzone",
    "subtitle": "A Battle Royale Experience",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/1642490/header.jpg",
    "description": "Call of Duty: Warzone is a free-to-play battle royale game that features intense combat, tactical gameplay, and a wide variety of weapons. Players drop into a massive open map, scavenge for weapons and gear, and compete to be the last team or player standing. The game features multiple game modes, including solos, duos, and squads, with a variety of unique mechanics like the Gulag, where eliminated players can fight for a chance to re-enter the game. Warzone features cross-platform play, seasonal updates, and new content regularly.",
    "developer": "Infinity Ward",
    "publisher": "Activision",
    "releaseDate": "March 10, 2020",
    "category": [
      "PC Games",
      "PS4",
      "Xbox One",
      "Battle Royale"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 64-bit",
        "Processor: Intel Core i3-4340 or AMD FX-6300",
        "Memory: 8 GB RAM",
        "Graphics: Nvidia GeForce GTX 960 2GB or AMD Radeon RX 470",
        "Storage: 175 GB available space"
      ],
      "recommended": [
        "OS: Windows 10 64-bit",
        "Processor: Intel Core i5-2500K or AMD Ryzen R5 1600X",
        "Memory: 12 GB RAM",
        "Graphics: Nvidia GeForce GTX 970 4GB or AMD Radeon RX 580",
        "Storage: 175 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=0E44DClsX5Q"
    },
    "relatedGames": [
      {
        "title": "Fortnite",
        "slug": "fortnite",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1642490/header.jpg"
      },
      {
        "title": "Apex Legends",
        "slug": "apex-legends",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1642490/header.jpg"
      },
      {
        "title": "Battlefield V",
        "slug": "battlefield-v",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1642490/header.jpg"
      }
    ]
  },
  "starbound": {
    "title": "Starbound",
    "subtitle": "Explore, Build, and Survive in Space",
    "bannerImage": "https://cdn.cloudflare.steamstatic.com/steam/apps/211820/header.jpg",
    "description": "Starbound is a procedurally generated sandbox game set in space, where players take on the role of a space explorer. The game offers exploration, crafting, and combat across an endless universe filled with planets, alien creatures, and hidden treasures. Players can build structures, fight enemies, and engage in various quests while discovering new planets and improving their space-faring capabilities. With a strong emphasis on creativity, Starbound offers countless possibilities for exploration and adventure in the stars.",
    "developer": "Chucklefish",
    "publisher": "Chucklefish",
    "releaseDate": "July 22, 2016",
    "category": [
      "PC Games",
      "Indie",
      "Action Adventure"
    ],
    "systemRequirements": {
      "minimum": [
        "OS: Windows 7 or later",
        "Processor: 2.0 GHz",
        "Memory: 2 GB RAM",
        "Graphics: OpenGL 2.1 compatible graphics card",
        "Storage: 2 GB available space"
      ],
      "recommended": [
        "OS: Windows 7 or later",
        "Processor: 2.0 GHz",
        "Memory: 4 GB RAM",
        "Graphics: OpenGL 2.1 compatible graphics card",
        "Storage: 2 GB available space"
      ]
    },
    "youtubeTrailerLink": {
      "youtubeLink": "https://www.youtube.com/watch?v=2XaY2Nx8F0A"
    },
    "relatedGames": [
      {
        "title": "Terraria",
        "slug": "terraria",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/211820/header.jpg"
      },
      {
        "title": "No Man's Sky",
        "slug": "no-mans-sky",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/211820/header.jpg"
      },
      {
        "title": "Space Engineers",
        "slug": "space-engineers",
        "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/211820/header.jpg"
      }
    ]
  }
}


export const GAMING_CATEGORY = [
  "PC Games",
  "Top Games",
  "Strategy Games",
  "Nintendo Switch",
  "Simulation Games",
  "PS4",
  "PS5",
  "Action Adventure",
  "Action RPG",
  "Competitive Games",
  "Co-op RPG",
  "FPS Games",
  "Co-op Games",
  "Open-World Games",
  "Sandbox Games",
  "Survival Games",
  "Life Simulation",
  "FPS",
  "Multiplayer",
  "Strategy",
  "RTS",
  "Simulation",
  "Xbox One",
  "RPG",
  "Turn-Based Combat",
  "MMO",
  "Shooter",
  "Battle Royale",
  "Indie"
];